var _path, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon0, _polygon1, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-136"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-136",
    d: "M77.67,232.92c-95.17,54.94-95.17,144,0,199s249.48,54.94,344.65,0,95.17-144,0-199S172.84,178,77.67,232.92Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-136"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--clouds--inject-136"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M249.63,86.29l3.72-2.87V75.21c0-6.51,5.2-14.06,10.83-17.32h0c5.64-3.25,10.21-.61,10.21,5.9V65a14.49,14.49,0,0,1,4.74-4.74h0c4.05-2.34,7.34-.45,7.34,4.24V65l5.2-3c2.67-1.54,4.84-.29,4.84,2.79a10.69,10.69,0,0,1-4.84,8.38l-42,24.27c-2.68,1.55-4.84.3-4.84-2.79A10.69,10.69,0,0,1,249.63,86.29Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.09,69.93l-6.75,3.9c0-.3.05-.6.05-.89V71c0-3.48-2.44-4.89-5.46-3.15A10.51,10.51,0,0,0,326.67,71c-.49-4.38-3.93-6-8.1-3.6-4.51,2.6-8.17,8.94-8.17,14.15v2.93a7.71,7.71,0,0,0,.69,3.39l-5.61,3.24a6.69,6.69,0,0,0-3,5.25c0,1.93,1.35,2.72,3,1.75l36.61-21.14a6.69,6.69,0,0,0,3-5.25C345.12,69.75,343.77,69,342.09,69.93Z",
    style: {
      fill: "#f5f5f5"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-136"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-136",
    d: "M219.75,321.88l-167,96.4a9.61,9.61,0,0,1-8.66,0L21.71,405.41c-2.39-1.37-2.39-3.61,0-5l167-96.4a9.57,9.57,0,0,1,8.66,0l22.4,12.87C222.14,318.26,222.14,320.5,219.75,321.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--shadow--inject-136",
    points: "320.71 374.11 243.85 329.87 234.27 335.38 224.2 329.58 79.15 413.07 156.01 457.31 165.59 451.8 175.66 457.59 320.71 374.11",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-136",
    d: "M282.62,192.66,191,245.33c-12.92,7.44-11.39,20.4,3.44,28.95l122.85,70.87c74.16,42.93,197.94-46.23,138.66-79.47L326.17,190.47C311.35,181.91,295.55,185.22,282.62,192.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-136",
    d: "M376.65,379.33v0a3,3,0,0,0-.4-1.62,3,3,0,0,0-4.11-1.1h0l-1.52.89a9.36,9.36,0,0,0-10.83-1.06h0l-55.62,32.2a3.37,3.37,0,0,0-1.22.4l-4.44,2.57a3.53,3.53,0,0,0-1.17,1.14,4.36,4.36,0,0,0-.51,1.11,1.83,1.83,0,0,0-.06.25l-50.7,29.34h0l-2.16,2.09h0a3.22,3.22,0,0,0-.24.28h0c-3.33,1.94-11.51,8.81-13.44,13.39l.05.09a1.88,1.88,0,0,0-.16.79,3.26,3.26,0,0,0,.07.6l-1,.59a8.56,8.56,0,0,0-2.35,2.22,2.42,2.42,0,0,0-.2.39s0,0,0,.05a1,1,0,0,0,0,.14.38.38,0,0,0,0,.1v.09a.48.48,0,0,0,.05.17h0a.46.46,0,0,0,.23.2l0,0a1.43,1.43,0,0,0,.39.07h.24a8.12,8.12,0,0,0,3.1-.92h0l1.07-.62a2.86,2.86,0,0,0,.42.29,1.89,1.89,0,0,0,.73.24h0c4.94.6,15-3.07,18.32-5,.12,0,.25,0,.37-.06h0l2.89-.83h0l50.7-29.35a3.92,3.92,0,0,0,3-.27l4.44-2.57a3.38,3.38,0,0,0,1-.86l55.61-32.19h0a9.33,9.33,0,0,0,4.62-8.81v-.06a9,9,0,0,0-.15-1l1.53-.88h0a3,3,0,0,0,.57-.43l.13-.15a3.22,3.22,0,0,0,.32-.41l.1-.16a3.14,3.14,0,0,0,.24-.57.14.14,0,0,1,0-.06,2.76,2.76,0,0,0,.11-.7v0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-136",
    d: "M439.11,450.71l-7.68-1-1.82-1.84-1.95-.59-.07-.53-1.2-.22-1.35-1.3-3.91-1-2.25-2.31-3.17-.36-13.94-8a25.85,25.85,0,0,1-6.17.71h0A28.15,28.15,0,0,1,382.36,431l-12.91-7c-2.72-1.48-4.36-3.61-4.48-5.84a5.37,5.37,0,0,1,2.53-4.71A83.2,83.2,0,0,1,379,406.71a14.43,14.43,0,0,1,6.19-1.27,17.24,17.24,0,0,1,8.76,2.3l12.2,7.46c3.51,2.15,5.62,4.95,5.95,7.89a7.09,7.09,0,0,1-1,4.47L424,435l.6,1.78L428.4,438l1.82,2.26,2.32.8.47.85.91,0,.85.94,3.35,1.1,2.1,5.29A1,1,0,0,1,439.11,450.71Zm-53.35-39.48a5.93,5.93,0,0,0-2.48.48c-1.92.92-3.73,1.87-5.38,2.83s-3.51,2.13-5.22,3.32c-.22.16-.29.28-.29.31s.31.65,1.2,1.14l.18.1a6.58,6.58,0,0,1,1.56-1.5,82.09,82.09,0,0,1,11.39-6.62A7.73,7.73,0,0,0,385.76,411.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-136",
    d: "M459.52,411.32c-16.48,0-33.42-.85-50.34-2.52-4.6-.44-8.21-2.94-8.59-5.94l-2.15-17.28a4.25,4.25,0,0,1,1.07-3.35c1.34-1.54,3.76-2.45,6.64-2.5s5.56-.07,8.33-.07c16.68,0,33.64.84,50.41,2.5,4.6.46,8.2,3,8.56,5.94l2.15,17.28a4.24,4.24,0,0,1-1.06,3.36c-1.34,1.54-3.75,2.45-6.63,2.5s-5.6.08-8.39.08Zm-51.63-11.8-1.3-10.39a2.2,2.2,0,0,0-.83-.2h-.23l1.29,10.38a2.21,2.21,0,0,0,.84.21Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Car--inject-136"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--car--inject-136"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M410.86,197.93h0l.74,3.07c1.7,3.19,5.46,7.21,6.81,6.88s1.95-2.06,2.33-4.22v0a21.14,21.14,0,0,0,.31-3.14c.12-3.41-1.4-11.36-6.14-13.47a2.44,2.44,0,0,0-2.81.63,5.65,5.65,0,0,0-1.37,2.25C409.94,192.3,410.75,197.8,410.86,197.93Z",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.86,197.93h0c.25,1.27.74,3.07.74,3.07,1.7,3.19,5.46,7.21,6.81,6.88s1.95-2.06,2.33-4.22v0a21.14,21.14,0,0,0,.31-3.14c.12-3.41-1.4-11.36-6.14-13.47a2.44,2.44,0,0,0-2.81.63,5.65,5.65,0,0,0-1.37,2.25C409.94,192.3,410.75,197.8,410.86,197.93Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.6,201c1.7,3.19,5.46,7.21,6.81,6.88s1.95-2.06,2.33-4.22v0a21.14,21.14,0,0,0,.31-3.14c.12-3.41-1.4-11.36-6.14-13.47a2.44,2.44,0,0,0-2.81.63l.65,1.46c3.31,1.41,4.21,6.52,3.9,10.41S413.5,203,411.6,201Z",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.6,201c1.7,3.19,5.46,7.21,6.81,6.88s1.95-2.06,2.33-4.22v0a21.14,21.14,0,0,0,.31-3.14c.12-3.41-1.4-11.36-6.14-13.47a2.44,2.44,0,0,0-2.81.63l.65,1.46c3.31,1.41,4.21,6.52,3.9,10.41S413.5,203,411.6,201Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.74,189.91c1.2-1.27,4.17-1.34,6.67,2.1s3.32,9.33,3.33,11.62a22.55,22.55,0,0,0,.32-3.14c.12-3.41-1.4-11.36-6.14-13.48C412.94,186.13,411.31,188.15,410.74,189.91Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--back-car--inject-136"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "189.32 238.01 222.24 219.02 203.95 208.47 186.15 219.7 189.32 238.01",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.32 238.01 222.24 219.02 203.95 208.47 186.15 219.7 189.32 238.01",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.2,233.5l-4.73-9.38,11.25-6.5h0c3.58-2.06,8.34-1.82,13.57,1.19,11.11,6.41,13.44,19.09,13.44,33.07,0,7.32,4.2,16.34.26,18.68h0l-.16.09h0l-11.53,6.65-5-9.89C210.85,260.21,203.56,246,203.2,233.5Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.2,233.5l-4.73-9.38,11.25-6.5h0c3.58-2.06,8.34-1.82,13.57,1.19,11.11,6.41,13.44,19.09,13.44,33.07,0,7.32,4.2,16.34.26,18.68h0l-.16.09h0l-11.53,6.65-5-9.89C210.85,260.21,203.56,246,203.2,233.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.47,239.27c0,12.06,6.7,26,15.67,33.72l0,0a28.68,28.68,0,0,0,4.41,3.16c11.11,6.41,20.12.27,20.11-13.71,0-10.56-5.14-22.59-12.44-30.59l-.07-.07a32.41,32.41,0,0,0-7.6-6.26C200.48,219.16,191.47,225.29,191.47,239.27Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.59,234c-7.07-4.08-12.8.17-12.8,9.49s5.73,20.19,12.8,24.26,12.8-.17,12.8-9.49S218.66,238.08,211.59,234Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.82,248.25c.45,4.64,3.4,9.58,6.58,11a3.11,3.11,0,0,0,3.49-.26c1.13-.95,1.71-2.91,1.46-5.51-.45-4.64-3.39-9.58-6.58-11a3.59,3.59,0,0,0-2.34-.33h0C206.59,242.59,205.5,244.88,205.82,248.25Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207,247.66c.45,4.64,3.4,9.58,6.58,11a3.65,3.65,0,0,0,2.34.33c1.13-.95,1.71-2.91,1.46-5.51-.45-4.64-3.39-9.58-6.58-11a3.59,3.59,0,0,0-2.34-.33h0C207.3,243.11,206.72,245.07,207,247.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.47,239.27c0,12.06,6.7,26,15.67,33.72a57,57,0,0,1-12.76-24.66c-1.7-8.06-1.06-19.63,5.86-22.55s16.06,3.24,18.95,6a32.41,32.41,0,0,0-7.6-6.26C200.48,219.16,191.47,225.29,191.47,239.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270,236.63l.41.24Z",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.6,234.09m7.22,4.17,0,0h0Zm-87.94-19.83c0,7.71,0,12.1.56,14.82a5.73,5.73,0,0,0,3.82,4.77c0-16.31,10.65-23.39,23.78-15.81,12.09,7,23.38,24.81,24.86,40.19a36.73,36.73,0,0,1,.21,3.88l66.23,38.09,0-44.34a1.87,1.87,0,0,1,1.71-.59c2.59.63,10.1,4.43,9.63,2.25-2.56-12-12-36.66-22.51-50.61-7.07-9.36-54.83-35-54.83-35-15.69-7.7-36.72,9.63-36.72,21.18C189.77,200.21,184.88,209.53,184.88,218.43Zm31.86-32.73c7.22-5.74,29.52,4.51,35.75,6.25,2.83.79,3.8,3.94,3.68,7.48,0,6.71,0,12.75,0,18.43,0,2.24-.16,4.84-2.31,3.6l0,0-.25-.14,0,0-39.71-22.88C210.51,196.47,211.86,189.58,216.74,185.7Zm45.39,40.64a5,5,0,0,1-2.68-4.88v-22c0-.61,0-1.14.07-1.56.08-.87,1.08-1.59,3.85-.09,2.23,1.19,5.53,3.05,11.84,6.88,2.54,1.53,12.92,7.45,18.14,18.08,2.29,4.66,9.79,18.26,10.94,27.75C304.16,250.44,262.17,226.37,262.13,226.34Z",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.6,234.09m7.22,4.17,0,0h0Zm-87.94-19.83c0,7.71,0,12.1.56,14.82a5.73,5.73,0,0,0,3.82,4.77c0-16.31,10.65-23.39,23.78-15.81,12.09,7,23.38,24.81,24.86,40.19a36.73,36.73,0,0,1,.21,3.88l66.23,38.09,0-44.34a1.87,1.87,0,0,1,1.71-.59c2.59.63,10.1,4.43,9.63,2.25-2.56-12-12-36.66-22.51-50.61-7.07-9.36-54.83-35-54.83-35-15.69-7.7-36.72,9.63-36.72,21.18C189.77,200.21,184.88,209.53,184.88,218.43Zm31.86-32.73c7.22-5.74,29.52,4.51,35.75,6.25,2.83.79,3.8,3.94,3.68,7.48,0,6.71,0,12.75,0,18.43,0,2.24-.16,4.84-2.31,3.6l0,0-.25-.14,0,0-39.71-22.88C210.51,196.47,211.86,189.58,216.74,185.7Zm45.39,40.64a5,5,0,0,1-2.68-4.88v-22c0-.61,0-1.14.07-1.56.08-.87,1.08-1.59,3.85-.09,2.23,1.19,5.53,3.05,11.84,6.88,2.54,1.53,12.92,7.45,18.14,18.08,2.29,4.66,9.79,18.26,10.94,27.75C304.16,250.44,262.17,226.37,262.13,226.34Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.18,228.53a8.4,8.4,0,0,0-1.27,3.32s-40-24.18-46.66-27.46a15.36,15.36,0,0,0-20,5.76,15.93,15.93,0,0,1,7.67-8.48c6.6-3,10.23-1.15,22.68,5.39S256.18,228.53,256.18,228.53Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.48,252.59l-34.82-19.88a3.42,3.42,0,0,0-1.35,3Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.55,245.59a.27.27,0,0,0,.41-.24v-1.28c0-1-1.45-2.58-3.24-3.62l-2.64-1.52c-1.78-1-3.23-1.08-3.23-.11v1a1.22,1.22,0,0,0,.61,1.06Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.55,292.33l-34.41-16.94,34.41,21.47c1.92,1.42,3.72,2.31,4.51-7.26s1.36-24.52,0-30.68c0,0,.12,13.78-1,22S299.52,293.38,297.55,292.33ZM256.8,239.64c.88,6.48,2.33,34.32,2.33,34.32s.08-25.74.08-33.55c0-6.5,2.56-9.49,2.56-9.49l-2.55-1.41S255.92,233.16,256.8,239.64Z",
    style: {
      fill: "#76ABAE",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.61,248.52c-.8-4.13-4.31-14.08-10.26-26.17A56.12,56.12,0,0,0,281.89,206c-5-3.85-15.5-9.82-18.87-11.83l-.86-.46c-4.2-2.23-28.58-16.44-37.28-14.73a20.06,20.06,0,0,0-12.9,8.83c-2.7,4.72-2.4,10.22,1.8,12.66,6.64,3.86,44.59,25.53,46.11,26.48s1.86,1.18,3.13,1.9c7.43,4.29,24.75,14.56,24.75,14.56s9.13,5.16,15.7,8.77c.3.15,1.56.77,1.84.87C306.91,253.66,305.82,249.65,305.61,248.52Zm-51.73-27.84h0a1.82,1.82,0,0,1-.26-.15l-.05,0c-6.19-3.57-28.66-16.51-38.61-22.26-3.34-1.92-3-8.52,1.81-12.53,9.93-8.36,24.78.06,35.75,6.25,2.56,1.44,3.8,3.94,3.68,7.48,0,6.71,0,12,0,17.65C256.18,219.32,256,221.92,253.88,220.68Zm19.86,11.46a1.33,1.33,0,0,1-.28-.16l0,0s0,0,0,0l-.2-.11-.08,0c-3.64-2-8.26-4.67-10.69-6.17a.75.75,0,0,0-.17-.1l-.12-.08a5,5,0,0,1-2.68-4.88V199.43c0-.61,0-1.14.07-1.56.08-.87,1.07-1.59,3.85-.1,2.23,1.2,5.52,3.06,11.84,6.89,2.54,1.53,12.93,8.12,18.15,18.76a145.45,145.45,0,0,1,10,25.75C303.21,249.12,286.26,239,273.74,232.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.18,217.08c0,2.24-.16,4.84-2.3,3.6h0a1.82,1.82,0,0,1-.26-.15l-.05,0c-6.19-3.57-28.66-16.51-38.61-22.26-3.34-1.92-3-8.52,1.81-12.53,9.93-8.36,24.78.06,35.75,6.25,2.56,1.44,3.8,3.94,3.68,7.48C256.17,206.14,256.18,211.4,256.18,217.08Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.21,231.84l-.15-.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.51,230.28l.91.52-.4-.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.8,225.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.18,231.82l-.31-.18-.1,0,.42.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.1,231.19l-.28-.15a1.16,1.16,0,0,0-.22-.13l.86.49.36.21-.28-.16-.08,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.45,220.56a5,5,0,0,0,2.68,4.88l.13.08a1.84,1.84,0,0,1,.16.1c2.42,1.49,7.05,4.18,10.68,6.16l.09.05.2.12s0,0,0,0l0,0,.28.15c12.53,6.83,29.47,17,29.59,17a145.61,145.61,0,0,0-10-25.75c-5.22-10.63-15.61-17.23-18.15-18.76-6.31-3.83-9.61-5.69-11.84-6.88-2.77-1.5-3.77-.78-3.85.09,0,.42-.07.95-.07,1.56Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.59,184.93c8.93-11.73,21.74-25.64,57.41-43.51s42.08-19.61,61.23-10.48l0,0c10.31,4.57,49.62,24.84,56.18,31.88,0,0-1.6.42-2.61.62-12.41,3.37-75.67,41.45-86.13,48.42a8.15,8.15,0,0,0-.59-.8c-7.07-9.36-54.83-35-54.83-35-9.09-4.53-21.77-.62-30.74,8.92Z",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.59,184.93c8.93-11.73,21.74-25.64,57.41-43.51s42.08-19.61,61.23-10.48l0,0c10.31,4.57,49.62,24.84,56.18,31.88,0,0-1.6.42-2.61.62-12.41,3.37-75.67,41.45-86.13,48.42a8.15,8.15,0,0,0-.59-.8c-7.07-9.36-54.83-35-54.83-35-9.09-4.53-21.77-.62-30.74,8.92Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--front-car--inject-136"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "304.35 304.38 337.26 285.39 318.98 274.84 304.35 283.31 304.35 304.38",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "304.35 304.38 337.26 285.39 318.98 274.84 304.35 283.31 304.35 304.38",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.9,299.66l-4.73-9.38,11.25-6.51h0c3.58-2,8.34-1.82,13.57,1.2,11.11,6.41,20.12,22.93,20.12,36.91,0,7.32-2.47,12.49-6.42,14.83h0l-.16.09h0L340,343.48l-5-9.9C325.55,326.36,318.26,312.13,317.9,299.66Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.9,299.66l-4.73-9.38,11.25-6.51h0c3.58-2,8.34-1.82,13.57,1.2,11.11,6.41,20.12,22.93,20.12,36.91,0,7.32-2.47,12.49-6.42,14.83h0l-.16.09h0L340,343.48l-5-9.9C325.55,326.36,318.26,312.13,317.9,299.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.17,305.43c0,12.05,6.7,26,15.67,33.72l0,0a29.17,29.17,0,0,0,4.41,3.16c11.11,6.42,20.12.27,20.11-13.71,0-10.56-5.14-22.58-12.44-30.59,0,0,0,0-.06-.06a32.66,32.66,0,0,0-7.61-6.26C315.18,285.31,306.17,291.45,306.17,305.43Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.29,300.15c-7.07-4.07-12.8.18-12.8,9.5s5.73,20.18,12.8,24.26,12.8-.18,12.8-9.5S333.36,304.23,326.29,300.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.5,314.45c.49,4.64,3.48,9.55,6.67,11a3.11,3.11,0,0,0,3.48-.29c1.12-1,1.69-2.92,1.42-5.52-.48-4.64-3.46-9.55-6.66-11a3.58,3.58,0,0,0-2.34-.31h0C321.22,308.79,320.15,311.08,320.5,314.45Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.65,313.85c.48,4.64,3.47,9.55,6.66,11a3.63,3.63,0,0,0,2.34.31c1.12-1,1.69-2.92,1.42-5.52-.48-4.64-3.46-9.55-6.66-11a3.58,3.58,0,0,0-2.34-.31h0C322,309.3,321.37,311.26,321.65,313.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.17,305.43c0,12.05,6.7,26,15.67,33.72a57.1,57.1,0,0,1-12.76-24.67c-1.7-8.06-1.06-19.62,5.86-22.55s16.07,3.24,19,6.05a32.66,32.66,0,0,0-7.61-6.26C315.18,285.31,306.17,291.45,306.17,305.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.75,255.06s6.15.44,8.51,1.22c2.09.69,24.36,0,46.37-9.66,13.17-5.75,23.2-10.52,34.42-20.14,14.61-12.55,16.32-23.67,17.8-27.07,6,4.29,14.44,12.94,19.13,16.56,10.78,8.95,23.9,22.19,29.1,36.84.35,1,.67,2,.94,3,7.69,28,1.1,38.27-5.48,46.83-2.8,3.63-10.59,10.71-20.29,16.49a243,243,0,0,1-24.66,12.62,88,88,0,0,1-15.42,5.17c-26.68,5.89-44.57-5.32-44.57-5.32a21,21,0,0,0-.05-4.44,45.58,45.58,0,0,0-1.06-5.89,59,59,0,0,0-5.63-14.35c-3.8-6.92-8.89-13-14.55-16.91-.74-.52-1.5-1-2.25-1.44-12.25-7.06-22.34-1.37-23.64,12.65-.09,1-.07,2.06-.07,3.17l-.64-12.9.58-34.39S306.2,256.72,305.75,255.06Z",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.75,255.06s6.15.44,8.51,1.22c2.09.69,24.36,0,46.37-9.66,13.17-5.75,23.2-10.52,34.42-20.14,14.61-12.55,16.32-23.67,17.8-27.07,6,4.29,14.44,12.94,19.13,16.56,10.78,8.95,23.9,22.19,29.1,36.84.35,1,.67,2,.94,3,7.69,28,1.1,38.27-5.48,46.83-2.8,3.63-10.59,10.71-20.29,16.49a243,243,0,0,1-24.66,12.62,88,88,0,0,1-15.42,5.17c-26.68,5.89-44.57-5.32-44.57-5.32a21,21,0,0,0-.05-4.44,45.58,45.58,0,0,0-1.06-5.89,59,59,0,0,0-5.63-14.35c-3.8-6.92-8.89-13-14.55-16.91-.74-.52-1.5-1-2.25-1.44-12.25-7.06-22.34-1.37-23.64,12.65-.09,1-.07,2.06-.07,3.17l-.64-12.9.58-34.39S306.2,256.72,305.75,255.06Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.73,287.58c1.44,1.87,3.84,2.28,5.38.93a4.36,4.36,0,0,0,.18-5.83c-1.44-1.87-3.85-2.29-5.38-.93A4.34,4.34,0,0,0,421.73,287.58Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413,212.26C396.72,237,364.39,254.5,327.71,261.5c-2.23.42-3.12,2.4-1.22,3.64,3.37,2.21,9.07,3.39,16.3,2,33-9.65,55.84-22.17,71.44-40.08a21.31,21.31,0,0,0,4.07-7,12.32,12.32,0,0,0-.39-8.32C416.92,209.71,414.25,210.36,413,212.26Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.59,331.74a86.65,86.65,0,0,1-9.69,3.62c4-1.58.62-9.46,3.61-12.39s13.15-7.73,25.28-14.72,20.3-14.58,22.15-12.23c3.32,4.21,5.93,3.43,5.94,3.42-.76,1.11-1.55,2.16-2.34,3.19-2.8,3.63-10.59,10.71-20.29,16.49A243,243,0,0,1,411.59,331.74Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "401.31 335.54 401.31 335.54 401.31 335.54 401.31 335.54",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M415.91,204.17a104.76,104.76,0,0,1,17.54,22.91,82.59,82.59,0,0,1,9.35,27.13,78.16,78.16,0,0,1,1.15,14.3,37.8,37.8,0,0,1-2.75,13.87,12.24,12.24,0,0,1-.73,1.61c-.28.52-.54,1.05-.83,1.56a28.58,28.58,0,0,1-2,2.89,26.49,26.49,0,0,1-2.34,2.63,30.76,30.76,0,0,1-2.7,2.26,42.29,42.29,0,0,1-6.1,3.66,62.43,62.43,0,0,1-6.55,2.9c-1.1.45-2.24.77-3.37,1.14-.57.16-1.15.29-1.72.44l-.87.21-.87.15a30.32,30.32,0,0,1-7.05.53,44.08,44.08,0,0,1-13.88-3c-2.23-.83-4.44-1.79-6.67-2.75l-6.7-2.82c-4.46-1.87-9-3.64-13.57-5.24s-9.19-3.08-13.82-4.51-9.27-2.75-13.72-4.6a56.49,56.49,0,0,1-12.61-6.93,33.39,33.39,0,0,1-9.47-10.79,32.54,32.54,0,0,0,9.2,11.13,56.46,56.46,0,0,0,12.57,7.33A142.44,142.44,0,0,0,351.12,285c4.59,1.5,9.18,3,13.7,4.71s9,3.48,13.45,5.36l6.67,2.85c2.21,1,4.44,1.94,6.73,2.81a45.61,45.61,0,0,0,14.34,3.2,32.78,32.78,0,0,0,7.4-.52l.91-.15.91-.22c.59-.15,1.2-.28,1.79-.45,1.18-.37,2.37-.7,3.51-1.16a67.13,67.13,0,0,0,6.7-3,44.67,44.67,0,0,0,6.31-3.84,34,34,0,0,0,2.84-2.4,29.79,29.79,0,0,0,2.47-2.8,28.32,28.32,0,0,0,2.1-3.08c.3-.54.57-1.1.86-1.64a15.26,15.26,0,0,0,.77-1.7,39.3,39.3,0,0,0,2.79-14.42A73.09,73.09,0,0,0,444,254a83.58,83.58,0,0,0-9.89-27.3A101.61,101.61,0,0,0,415.91,204.17Z",
    style: {
      fill: "#76ABAE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M380.51,239.12s24.62-13.77,33.76-35.49a92.33,92.33,0,0,1,17.1,23.08A111.56,111.56,0,0,1,441,255.05s-5.45-21.13-14.74-34.14c-8.72-12.19-10.84-15.19-15.85-7.2C406.55,219.84,394.17,234.67,380.51,239.12Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.25,279.5c6.11,1.5,17.66,4.36,27.24,8.2s21.7,11.33,34.22,12.71,25-6.09,25-6.09-12.83,5.91-24.7,4.29-23.29-8.86-35.1-13S342.25,279.5,342.25,279.5Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359,319.79c1.17-.16,4.08.62,9,2s6.14,1.55,8,2.81c1.55,1.07,5.69,4.44,7.69,5.47,3.17,1.64,0,2.82-8.87,2.83s-11.86-2.65-13.9-5.37S356.33,320.16,359,319.79Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463,271.66a39.33,39.33,0,0,1,.5,4.85,23,23,0,0,1-1.82,9.34c-.39.91-1.07,1.93-2.05,1.84-.39,0,.43-13.49.61-14.79s.35-2.41.52-3.62c.06-.44.23-1,.67-1C462.18,268.17,462.68,269.81,463,271.66Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449,259.81c-.89-3.77-.83-10-1-13.85a54.2,54.2,0,0,0-1.26-10.78c-.47-2.4-.81-4.37-.08-5.22,6.1,6.83,11.53,14.61,14.45,22.85.35,1,.67,2,.94,3s.52,1.91.75,2.83c-.56,2.88-3.12,6.83-6.49,7.17C452.39,266.2,449.85,263.58,449,259.81Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.44,231.79a3.17,3.17,0,0,0-2.32-.71c-.83.11-.47,1.37-.29,1.89l1,2.82c.23.69.37,1.57,1.29,1.61,1.12,0,1.72-1.29,1.91-2.2A3.66,3.66,0,0,0,450.44,231.79Z",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.44,231.79a3.17,3.17,0,0,0-2.32-.71c-.83.11-.47,1.37-.29,1.89l1,2.82c.23.69.37,1.57,1.29,1.61,1.12,0,1.72-1.29,1.91-2.2A3.66,3.66,0,0,0,450.44,231.79Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.2,263.29a3.83,3.83,0,0,1-5.06-.65,8.89,8.89,0,0,1-2.14-3.72c-2-5.93-1.05-12.4,0-18.57a3.66,3.66,0,0,1,.76-2c1.51-1.58,4.16,1.27,5.12,2.27a18.8,18.8,0,0,1,3.69,5.63c1.21,2.85,2.34,7,1.71,10.12C461.76,258.83,460.39,261.9,458.2,263.29Z",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.2,263.29a3.83,3.83,0,0,1-5.06-.65,8.89,8.89,0,0,1-2.14-3.72c-2-5.93-1.05-12.4,0-18.57a3.66,3.66,0,0,1,.76-2c1.51-1.58,4.16,1.27,5.12,2.27a18.8,18.8,0,0,1,3.69,5.63c1.21,2.85,2.34,7,1.71,10.12C461.76,258.83,460.39,261.9,458.2,263.29Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.32,242.93a8.32,8.32,0,0,1,.49,10,2.64,2.64,0,0,1-1.7,1.25,2.07,2.07,0,0,1-1.87-1.05,5.14,5.14,0,0,1-.62-2.15,42.33,42.33,0,0,1-.15-6.94C452.58,241.17,454.65,241,456.32,242.93Z",
    style: {
      fill: "#fff",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.6,298.25c-4.09-3.47-10.46-6.43-21.05-7.47-9.43-.92-17.82-5.24-18.1-.54s7.23,18.83,20.94,23.58c11.83,4.09,19.36.89,21.87-3.09S382.68,301.73,378.6,298.25Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.05,296.18a3,3,0,0,1-3.72-1.9c-.53-1.14-1-2.83.46-3.44,2-.84,4.7-.16,6.57.75C353.09,293.39,347.79,295.72,346.05,296.18Z",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.05,296.18a3,3,0,0,1-3.72-1.9c-.53-1.14-1-2.83.46-3.44,2-.84,4.7-.16,6.57.75C353.09,293.39,347.79,295.72,346.05,296.18Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.68,302.59c-1.19-2.14-1.84-4.6-.17-6.32s5-2.27,7.24-2.49a27.1,27.1,0,0,1,19.66,6.1,12.57,12.57,0,0,1,3.17,3.65,6.13,6.13,0,0,1,.57,4.71c-2.34,7.2-13.48,6.08-18.92,4a23,23,0,0,1-9.17-6.38A20.14,20.14,0,0,1,350.68,302.59Z",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.68,302.59c-1.19-2.14-1.84-4.6-.17-6.32s5-2.27,7.24-2.49a27.1,27.1,0,0,1,19.66,6.1,12.57,12.57,0,0,1,3.17,3.65,6.13,6.13,0,0,1,.57,4.71c-2.34,7.2-13.48,6.08-18.92,4a23,23,0,0,1-9.17-6.38A20.14,20.14,0,0,1,350.68,302.59Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.35,295.44a23.74,23.74,0,0,1,4.51,1.38c1.62.67,3.29,2,3.13,3.77-.35,3.76-7.46,5.52-10.52,5.38a9,9,0,0,1-7.67-4.64C349.4,294.48,359.84,294.86,363.35,295.44Z",
    style: {
      fill: "#fff",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.71,211.88c6.11,9.64,12.55,22.71,18.77,44.8,4.4,4.57,48-.92,83-29.21,12.91-10.46,19.44-24.6,17.29-28.32-10.74-15-15.95-24-30.3-36.31C370.34,163.26,304.17,204.91,293.71,211.88Zm6.71,4.47a4.44,4.44,0,0,1,1.29-5.74c20.13-14.49,59.76-37.25,77.11-44.82a4.41,4.41,0,0,1,4.73.76c12.66,11.47,18.13,20.6,26.58,33.58-.27,1-1.09,13.65-17.76,26.34-31.66,24.1-65.08,28.58-76.05,28.58a1.13,1.13,0,0,1-1.18-.84C311.11,240.14,308.25,230.47,300.42,216.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.14,254.21a1.13,1.13,0,0,0,1.18.84c11,0,44.39-4.48,76.05-28.58,16.67-12.69,17.49-25.36,17.76-26.34-8.45-13-13.92-22.11-26.58-33.58a4.41,4.41,0,0,0-4.73-.76c-17.35,7.57-57,30.33-77.11,44.82a4.44,4.44,0,0,0-1.29,5.74C308.25,230.47,311.11,240.14,315.14,254.21Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.3,239.7a135,135,0,0,0,24-14.59c15.72-12,16.49-23.9,16.75-24.83-8-12.24-13.13-20.85-25.06-31.66a4.18,4.18,0,0,0-4.47-.72c-2.91,1.27-6.5,3-10.52,5.06,2.48,4.64,5.42,9.08,7.64,13.86a79.68,79.68,0,0,1,6.42,19.54c1.72,9.7,0,20-7.1,27.12A51.7,51.7,0,0,1,367.3,239.7Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293,257.66c1.53,7.24,9.56,8.77,15.57,8.59a18.41,18.41,0,0,0,6.61-1.13c2.32-1.34,1.25-4.12,0-5.73-2.11-2.73-11.56-8.2-17.5-8.39C294.23,250.89,292,252.58,293,257.66Z",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293,257.66c1.53,7.24,9.56,8.77,15.57,8.59a18.41,18.41,0,0,0,6.61-1.13c2.32-1.34,1.25-4.12,0-5.73-2.11-2.73-11.56-8.2-17.5-8.39C294.23,250.89,292,252.58,293,257.66Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293,257.66c1.53,7.24,9.56,8.77,15.57,8.59a18.41,18.41,0,0,0,6.61-1.13c2.32-1.34,1.25-4.12,0-5.73,1.17,2.21-5,3.58-10.54,1.6s-9.64-6.25-7-10C294.23,250.89,292,252.58,293,257.66Z",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293,257.66c1.53,7.24,9.56,8.77,15.57,8.59a18.41,18.41,0,0,0,6.61-1.13c2.32-1.34,1.25-4.12,0-5.73,1.17,2.21-5,3.58-10.54,1.6s-9.64-6.25-7-10C294.23,250.89,292,252.58,293,257.66Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293,257.66c1.53,7.24,9.56,8.77,15.57,8.59-6-.17-10.76-3.62-12.56-7.38s-.43-7.39,1.68-7.87C294.23,250.89,292,252.58,293,257.66Z",
    style: {
      fill: "#37474f"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clipboard--inject-136"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Contract--inject-136"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Board--inject-136"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-136"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.67,30.65,44.79,125.15a6.77,6.77,0,0,0-3.06,5.31v280.3a6.73,6.73,0,0,0,3.07,5.3l.62.35a6.81,6.81,0,0,0,6.14,0l163.87-94.62a6.76,6.76,0,0,0,3.07-5.31V36.29A6.75,6.75,0,0,0,215.43,31l-.63-.36A6.79,6.79,0,0,0,208.67,30.65Z",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.67,30.65,44.79,125.15a6.77,6.77,0,0,0-3.06,5.31v280.3a6.73,6.73,0,0,0,3.07,5.3l.62.35a6.81,6.81,0,0,0,6.14,0l163.87-94.62a6.76,6.76,0,0,0,3.07-5.31V36.29A6.75,6.75,0,0,0,215.43,31l-.63-.36A6.79,6.79,0,0,0,208.67,30.65Z",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.5,316.69c0,2.69-1.89,4.41-4.24,5.76L52.73,415.71c-2.33,1.34-4.24.26-4.24-2.45V135.66h0a8.44,8.44,0,0,1,4.22-7.31l161.55-93.3a2.83,2.83,0,0,1,4.24,2.45h0Z",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.5,316.69c0,2.69-1.89,4.41-4.24,5.76L52.73,415.71c-2.33,1.34-4.24.26-4.24-2.45V135.66h0a8.44,8.44,0,0,1,4.22-7.31l161.55-93.3a2.83,2.83,0,0,1,4.24,2.45h0Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.5,36.29V37.5a2.83,2.83,0,0,0-4.25-2.44L52.71,128.36a8.13,8.13,0,0,0-3.08,3.08.26.26,0,0,0-.05.09l-7-4a6.21,6.21,0,0,1,2.21-2.33L208.67,30.65a6.79,6.79,0,0,1,6.13,0l.62.36A6.73,6.73,0,0,1,218.5,36.29Z",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.5,36.29V37.5a2.83,2.83,0,0,0-4.25-2.44L52.71,128.36a8.13,8.13,0,0,0-3.08,3.08.26.26,0,0,0-.05.09l-7-4a6.21,6.21,0,0,1,2.21-2.33L208.67,30.65a6.79,6.79,0,0,1,6.13,0l.62.36A6.73,6.73,0,0,1,218.5,36.29Z",
    style: {
      opacity: 0.2
    }
  }))), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-136",
    d: "M214.5,308.26c0,2.77-1.95,4.54-4.36,5.93L57.47,402.34c-2.4,1.38-4.37.26-4.37-2.53V151.28h0a8.69,8.69,0,0,1,4.35-7.52L210.14,55.57a2.91,2.91,0,0,1,4.36,2.52V308.26Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Form--inject-136"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Paper--inject-136"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57,147.06,209.13,59.24a2.84,2.84,0,0,1,2.6,0l1.47.84a2.89,2.89,0,0,1,1.3,2.26V312.1a2.89,2.89,0,0,1-1.3,2.26L61.09,402.18a2.86,2.86,0,0,1-2.61,0L57,401.33a2.86,2.86,0,0,1-1.3-2.25V149.32A2.89,2.89,0,0,1,57,147.06Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.78,402.32a2.52,2.52,0,0,1-.49.13l-.25,0a3.49,3.49,0,0,1-.79,0,2.42,2.42,0,0,1-.48-.13l-.29-.14L57,401.34a2.89,2.89,0,0,1-1.31-2.26V149.32a2.56,2.56,0,0,1,.38-1.28l4.07,2.35a2.73,2.73,0,0,0-.38,1.28V401.43C59.78,402.14,60.2,402.49,60.78,402.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.2,60.08l-1.47-.84a2.84,2.84,0,0,0-2.6,0L57,147.06a2.89,2.89,0,0,0-1.3,2.26v28.77l4.07,2.37L214.5,91.13V62.34A2.89,2.89,0,0,0,213.2,60.08Z",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.2,60.08l-1.47-.84a2.84,2.84,0,0,0-2.6,0L57,147.06a2.89,2.89,0,0,0-1.3,2.26v28.77l4.07,2.37L214.5,91.13V62.34A2.89,2.89,0,0,0,213.2,60.08Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.46,61.94c-.16-.53-.67-.7-1.26-.36L61.09,149.41a2.63,2.63,0,0,0-.93,1L56.09,148a2.59,2.59,0,0,1,.93-1L209.13,59.24a2.84,2.84,0,0,1,2.6,0l1.47.84A2.89,2.89,0,0,1,214.46,61.94Z",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.46,61.94c-.16-.53-.67-.7-1.26-.36L61.09,149.41a2.63,2.63,0,0,0-.93,1L56.09,148a2.59,2.59,0,0,1,.93-1L209.13,59.24a2.84,2.84,0,0,1,2.6,0l1.47.84A2.89,2.89,0,0,1,214.46,61.94Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.71,149.32v28.79l4.07,2.35v-28.8a2.73,2.73,0,0,1,.38-1.28L56.09,148A2.56,2.56,0,0,0,55.71,149.32Z",
    style: {
      fill: "#76ABAE"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M180.47,147.11l-84.2,48.61c-.4.24-.73,0-.73-.55V171.94a1.75,1.75,0,0,1,.73-1.39l84.2-48.61c.4-.24.73,0,.73.55v23.22A1.76,1.76,0,0,1,180.47,147.11Z",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.47,147.11l-84.2,48.61c-.4.24-.73,0-.73-.55V171.94a1.75,1.75,0,0,1,.73-1.39l84.2-48.61c.4-.24.73,0,.73.55v23.22A1.76,1.76,0,0,1,180.47,147.11Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.74,170.61a.25.25,0,0,1,.29,0,.38.38,0,0,1,.13.32v2.18a1,1,0,0,1-.13.46.8.8,0,0,1-.29.33L117.6,178a.24.24,0,0,1-.29,0,.39.39,0,0,1-.12-.32V164.43a1,1,0,0,1,.12-.46.83.83,0,0,1,.29-.34l2-1.16a.24.24,0,0,1,.29,0,.36.36,0,0,1,.13.32v10.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.74,163.72a10.61,10.61,0,0,1,.38-2.39,11,11,0,0,1,.94-2.31,10.82,10.82,0,0,1,1.48-2,8.52,8.52,0,0,1,2-1.61,4.83,4.83,0,0,1,2-.71,2.35,2.35,0,0,1,1.49.33,2.62,2.62,0,0,1,.94,1.23,5.88,5.88,0,0,1,.37,1.95q0,.86,0,1.83t0,1.83a10.5,10.5,0,0,1-.37,2.38,11.4,11.4,0,0,1-.94,2.32,10.33,10.33,0,0,1-1.49,2.05,8.6,8.6,0,0,1-2,1.59,5,5,0,0,1-2,.73,2.2,2.2,0,0,1-1.48-.34,2.6,2.6,0,0,1-.94-1.23,5.87,5.87,0,0,1-.38-2c0-.55,0-1.15,0-1.79S126.72,164.32,126.74,163.72Zm6.77-.35q0-.37,0-.84c0-.31,0-.62,0-.94s0-.61,0-.9,0-.55,0-.77a2.93,2.93,0,0,0-.16-.86,1.18,1.18,0,0,0-.37-.53.84.84,0,0,0-.59-.16,2,2,0,0,0-.84.29,3.87,3.87,0,0,0-.83.67,4,4,0,0,0-.59.84,4.74,4.74,0,0,0-.37,1,5.12,5.12,0,0,0-.16,1c0,.24,0,.51,0,.81s0,.6,0,.92,0,.62,0,.92,0,.57,0,.8a1.91,1.91,0,0,0,.53,1.4c.31.27.79.22,1.42-.15a3.4,3.4,0,0,0,1.42-1.49A5.41,5.41,0,0,0,133.51,163.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.38,148.17c.2-.12.36-.13.47,0a.64.64,0,0,1,.22.32l3.36,11a.67.67,0,0,1,0,.65.65.65,0,0,1-.24.27l-1.95,1.12c-.2.12-.35.15-.44.08a.43.43,0,0,1-.16-.24l-.43-1.46-4.1,2.37-.43,1.95a1.65,1.65,0,0,1-.16.43,1.14,1.14,0,0,1-.44.43l-1.94,1.12a.2.2,0,0,1-.24,0,.3.3,0,0,1-.1-.26,1.67,1.67,0,0,1,.06-.35l3.36-14.89a2.68,2.68,0,0,1,.22-.58,1.17,1.17,0,0,1,.47-.49Zm-2.5,10.43,2.5-1.44-1.25-4.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.53,155a.44.44,0,0,1-.43.06.6.6,0,0,1-.2-.17l-3.53-5v6.95a.92.92,0,0,1-.13.46.74.74,0,0,1-.29.33l-2,1.17a.24.24,0,0,1-.29,0,.37.37,0,0,1-.12-.32V145.19a1,1,0,0,1,.12-.47.86.86,0,0,1,.29-.33l1.6-.92c.18-.11.32-.13.43-.06a.56.56,0,0,1,.21.16l3.53,5v-6.94a1,1,0,0,1,.12-.46.83.83,0,0,1,.29-.34l2-1.16a.26.26,0,0,1,.3,0,.38.38,0,0,1,.12.32v13.28a1,1,0,0,1-.12.46.75.75,0,0,1-.3.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.21,183.47a1.41,1.41,0,0,1,.57,0,1.07,1.07,0,0,1,.45.18,1,1,0,0,1,.29.33,1,1,0,0,1,.11.45.41.41,0,0,1,0,.17.25.25,0,0,1-.1.12l-.93.54a.29.29,0,0,1-.16.05.19.19,0,0,1-.12,0l-.07-.06-.13-.06h-.21a1.09,1.09,0,0,0-.31.13l-.26.17a1.49,1.49,0,0,0-.22.21.87.87,0,0,0-.16.23.66.66,0,0,0-.06.27.23.23,0,0,0,.07.2.34.34,0,0,0,.23,0,2.69,2.69,0,0,0,.42-.09l.65-.2a2.86,2.86,0,0,1,.68-.13.94.94,0,0,1,.49.12.82.82,0,0,1,.29.4,2.34,2.34,0,0,1,.09.72,3.07,3.07,0,0,1-.11.79,3.69,3.69,0,0,1-.32.77,3.8,3.8,0,0,1-.5.71,4.61,4.61,0,0,1-.63.62v.67a.42.42,0,0,1-.06.21.34.34,0,0,1-.14.15l-.92.54a.12.12,0,0,1-.14,0,.18.18,0,0,1-.06-.15v-.69a1.46,1.46,0,0,1-.61.05,1,1,0,0,1-.47-.17.88.88,0,0,1-.3-.36,1.19,1.19,0,0,1-.11-.51.41.41,0,0,1,.15-.3l.93-.53a.29.29,0,0,1,.15-.06.27.27,0,0,1,.12,0,.57.57,0,0,0,.08.08.53.53,0,0,0,.15.08.47.47,0,0,0,.24,0,1,1,0,0,0,.36-.14,2.87,2.87,0,0,0,.63-.47.75.75,0,0,0,.25-.54.18.18,0,0,0-.09-.18.58.58,0,0,0-.28,0,3.61,3.61,0,0,0-.47.12l-.68.2a1.07,1.07,0,0,1-1.06-.08,1.39,1.39,0,0,1-.34-1.1,2.84,2.84,0,0,1,.09-.69,3.52,3.52,0,0,1,.27-.72,4.55,4.55,0,0,1,.42-.69,4.76,4.76,0,0,1,.57-.62v-.7a.42.42,0,0,1,.06-.21.37.37,0,0,1,.14-.16l.92-.53a.12.12,0,0,1,.14,0s.06.07.06.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165,180.71a1.46,1.46,0,0,1,.58,0,1,1,0,0,1,.44.18,1.05,1.05,0,0,1,.29.34,1,1,0,0,1,.11.45.38.38,0,0,1,0,.17.32.32,0,0,1-.1.12l-.93.54a.47.47,0,0,1-.16.05.38.38,0,0,1-.13,0l-.06-.06-.14-.06a.72.72,0,0,0-.21,0,1.22,1.22,0,0,0-.31.13l-.26.17-.22.2a1.58,1.58,0,0,0-.15.24.66.66,0,0,0-.06.27.27.27,0,0,0,.06.2.31.31,0,0,0,.23,0,1.59,1.59,0,0,0,.42-.08l.65-.2a2.86,2.86,0,0,1,.68-.13.91.91,0,0,1,.49.12.76.76,0,0,1,.29.4,2.3,2.3,0,0,1,.1.72,2.71,2.71,0,0,1-.12.79,3.4,3.4,0,0,1-.32.77,3.75,3.75,0,0,1-.49.71,5.34,5.34,0,0,1-.64.62V188a.42.42,0,0,1-.06.21.39.39,0,0,1-.13.15l-.93.54a.12.12,0,0,1-.14,0,.21.21,0,0,1,0-.15v-.7a1.52,1.52,0,0,1-.62.06,1,1,0,0,1-.46-.17.88.88,0,0,1-.3-.36,1.37,1.37,0,0,1-.12-.52.41.41,0,0,1,0-.17.25.25,0,0,1,.1-.12l.93-.54a.47.47,0,0,1,.16,0l.11,0,.08.08a.48.48,0,0,0,.16.08.45.45,0,0,0,.24,0,1.12,1.12,0,0,0,.36-.14,2.87,2.87,0,0,0,.62-.47.75.75,0,0,0,.25-.54.18.18,0,0,0-.09-.18.45.45,0,0,0-.27,0,3.69,3.69,0,0,0-.48.12l-.67.2a1.11,1.11,0,0,1-1.07-.08,1.43,1.43,0,0,1-.34-1.1,2.88,2.88,0,0,1,.1-.69,4.2,4.2,0,0,1,1.26-2v-.7a.54.54,0,0,1,0-.21.38.38,0,0,1,.14-.16l.93-.53a.1.1,0,0,1,.13,0s.06.07.06.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.77,178a1.31,1.31,0,0,1,.58,0,1,1,0,0,1,.44.18,1,1,0,0,1,.3.34,1.06,1.06,0,0,1,.11.44.41.41,0,0,1,0,.18.25.25,0,0,1-.1.12l-.93.53a.35.35,0,0,1-.16.06.28.28,0,0,1-.12,0l-.07-.06a.23.23,0,0,0-.13-.06.37.37,0,0,0-.21,0,1,1,0,0,0-.32.13l-.25.17a1.07,1.07,0,0,0-.22.2.78.78,0,0,0-.16.24.66.66,0,0,0-.06.27.24.24,0,0,0,.07.2.33.33,0,0,0,.22,0,2.55,2.55,0,0,0,.43-.09l.65-.19a2.37,2.37,0,0,1,.68-.13.75.75,0,0,1,.48.12.76.76,0,0,1,.29.4,2,2,0,0,1,.1.71,3.15,3.15,0,0,1-.11.8,4.64,4.64,0,0,1-.32.77,4.16,4.16,0,0,1-.5.71,4.12,4.12,0,0,1-.64.61v.67a.47.47,0,0,1-.05.22.41.41,0,0,1-.14.15l-.93.54a.1.1,0,0,1-.13,0,.18.18,0,0,1-.06-.15v-.7a1.66,1.66,0,0,1-.61.06,1.15,1.15,0,0,1-.47-.17.88.88,0,0,1-.3-.36,1.21,1.21,0,0,1-.11-.52.38.38,0,0,1,0-.17.26.26,0,0,1,.11-.12l.92-.54a.32.32,0,0,1,.16-.05.2.2,0,0,1,.11,0l.09.07a.38.38,0,0,0,.15.09.6.6,0,0,0,.24,0,1,1,0,0,0,.36-.14,3.23,3.23,0,0,0,.63-.47.79.79,0,0,0,.25-.54q0-.15-.09-.18a.48.48,0,0,0-.28,0,3.61,3.61,0,0,0-.47.12l-.68.2a1.12,1.12,0,0,1-1.06-.08,1.42,1.42,0,0,1-.34-1.11,2.84,2.84,0,0,1,.09-.69,3.24,3.24,0,0,1,.27-.71,3.54,3.54,0,0,1,.42-.69,4.76,4.76,0,0,1,.57-.62V178a.49.49,0,0,1,.06-.22.39.39,0,0,1,.13-.15l.93-.54a.12.12,0,0,1,.14,0,.17.17,0,0,1,.05.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.56,175.19a1.3,1.3,0,0,1,.58,0,1,1,0,0,1,.44.18,1,1,0,0,1,.29.34.93.93,0,0,1,.11.44.33.33,0,0,1,0,.17.36.36,0,0,1-.11.13l-.93.53a.29.29,0,0,1-.15.06.35.35,0,0,1-.13-.05l-.07,0a.23.23,0,0,0-.13-.06.37.37,0,0,0-.21,0,.71.71,0,0,0-.31.13,1.45,1.45,0,0,0-.26.17,1.42,1.42,0,0,0-.22.2,1,1,0,0,0-.16.24.6.6,0,0,0-.06.27.28.28,0,0,0,.07.2.37.37,0,0,0,.23,0,2.48,2.48,0,0,0,.42-.09l.65-.19a2.12,2.12,0,0,1,.68-.13.76.76,0,0,1,.49.12.78.78,0,0,1,.29.4,2.32,2.32,0,0,1,.09.71,2.76,2.76,0,0,1-.11.8,3.92,3.92,0,0,1-.32.77,4.26,4.26,0,0,1-1.13,1.32v.67a.42.42,0,0,1-.06.21.36.36,0,0,1-.13.16l-.93.53a.14.14,0,0,1-.14,0,.21.21,0,0,1-.05-.15v-.7a1.73,1.73,0,0,1-.62.06,1.1,1.1,0,0,1-.46-.17,1,1,0,0,1-.31-.36,1.46,1.46,0,0,1-.11-.52.37.37,0,0,1,.05-.17.25.25,0,0,1,.1-.12l.93-.54a.33.33,0,0,1,.15-.06.28.28,0,0,1,.12,0l.08.07a.35.35,0,0,0,.16.09.46.46,0,0,0,.24,0,.84.84,0,0,0,.35-.14,2.87,2.87,0,0,0,.63-.47.72.72,0,0,0,.25-.53.19.19,0,0,0-.09-.19.6.6,0,0,0-.28,0,3.33,3.33,0,0,0-.47.11l-.67.21a1.14,1.14,0,0,1-1.07-.08,1.47,1.47,0,0,1-.34-1.11A2.84,2.84,0,0,1,172,178a3.83,3.83,0,0,1,.27-.71,4.17,4.17,0,0,1,.43-.69,3.73,3.73,0,0,1,.57-.63v-.7a.58.58,0,0,1,.05-.21.41.41,0,0,1,.14-.15l.93-.54a.1.1,0,0,1,.13,0,.18.18,0,0,1,.06.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.26,146.66,72.48,222.74c-.46.26-.83,0-.83-.63a2,2,0,0,1,.83-1.58l131.78-76.08c.45-.26.82,0,.82.63A2,2,0,0,1,204.26,146.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.26,154.52,72.48,230.6c-.46.27-.83,0-.83-.62a2,2,0,0,1,.83-1.58l131.78-76.08c.45-.27.82,0,.82.62A2,2,0,0,1,204.26,154.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.26,162.39l-25.6,14.77c-.45.27-.82,0-.82-.62a2,2,0,0,1,.82-1.59l25.6-14.77c.45-.26.82,0,.82.62A2,2,0,0,1,204.26,162.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.14,191.32,72.48,238.47c-.46.26-.83,0-.83-.63a2,2,0,0,1,.83-1.58l81.66-47.15c.46-.26.83,0,.83.63A2,2,0,0,1,154.14,191.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.26,170.25,72.48,246.33c-.46.26-.83,0-.83-.63a2,2,0,0,1,.83-1.58L204.26,168c.45-.26.82,0,.82.63A2,2,0,0,1,204.26,170.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.26,178.11,72.48,254.19c-.46.27-.83,0-.83-.62a2,2,0,0,1,.83-1.58l131.78-76.08c.45-.27.82,0,.82.62A2,2,0,0,1,204.26,178.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.1,205.12,72.48,262.06c-.46.26-.83,0-.83-.63a2,2,0,0,1,.83-1.58l98.62-56.94c.45-.26.82,0,.82.63A2,2,0,0,1,171.1,205.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.35,300a1.3,1.3,0,0,1,.58,0,1,1,0,0,1,.44.18,1,1,0,0,1,.29.34.93.93,0,0,1,.11.44.39.39,0,0,1,0,.18.32.32,0,0,1-.1.12l-.93.53a.35.35,0,0,1-.16.06.38.38,0,0,1-.13,0l-.06-.06a.26.26,0,0,0-.14-.06.37.37,0,0,0-.21,0,.94.94,0,0,0-.31.13l-.26.17a2.09,2.09,0,0,0-.22.2,1,1,0,0,0-.15.24.66.66,0,0,0-.06.27.27.27,0,0,0,.06.2.31.31,0,0,0,.23,0,2.29,2.29,0,0,0,.42-.09l.65-.19a2.43,2.43,0,0,1,.68-.13.72.72,0,0,1,.78.52,2.28,2.28,0,0,1,.1.71,2.77,2.77,0,0,1-.12.8,3.4,3.4,0,0,1-.32.77A4.09,4.09,0,0,1,95,306a5.26,5.26,0,0,1-.64.61v.67a.49.49,0,0,1-.06.22.39.39,0,0,1-.13.15l-.93.54a.12.12,0,0,1-.14,0,.21.21,0,0,1,0-.15v-.7a1.72,1.72,0,0,1-.62.06,1.1,1.1,0,0,1-.46-.17.88.88,0,0,1-.3-.36,1.37,1.37,0,0,1-.12-.52.41.41,0,0,1,0-.17.25.25,0,0,1,.1-.12l.93-.54a.32.32,0,0,1,.16,0l.11,0,.08.07a.35.35,0,0,0,.16.09.58.58,0,0,0,.24,0,1.12,1.12,0,0,0,.36-.14,3.14,3.14,0,0,0,.62-.47.75.75,0,0,0,.25-.54q0-.15-.09-.18a.45.45,0,0,0-.27,0,3.69,3.69,0,0,0-.48.12l-.67.2a1.14,1.14,0,0,1-1.07-.08,1.44,1.44,0,0,1-.34-1.11,2.88,2.88,0,0,1,.1-.69,4.07,4.07,0,0,1,.26-.71,4.45,4.45,0,0,1,1-1.31v-.7a.63.63,0,0,1,0-.22.41.41,0,0,1,.14-.15l.93-.54a.1.1,0,0,1,.13,0,.18.18,0,0,1,.06.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.13,297.24a1.31,1.31,0,0,1,.58,0,1,1,0,0,1,.44.18.87.87,0,0,1,.29.34,1.07,1.07,0,0,1,.12.44.41.41,0,0,1,0,.18.4.4,0,0,1-.1.12l-.93.53a.35.35,0,0,1-.16.06.31.31,0,0,1-.12-.05l-.07-.05a.23.23,0,0,0-.13-.06.37.37,0,0,0-.21,0,.79.79,0,0,0-.32.13,1.38,1.38,0,0,0-.25.17,1.07,1.07,0,0,0-.22.2.78.78,0,0,0-.16.24.6.6,0,0,0-.06.27.24.24,0,0,0,.07.2.33.33,0,0,0,.22,0,2.29,2.29,0,0,0,.42-.09l.66-.19a2.07,2.07,0,0,1,.68-.13.75.75,0,0,1,.48.12.72.72,0,0,1,.29.4,2,2,0,0,1,.1.71,3.15,3.15,0,0,1-.11.8,4.64,4.64,0,0,1-.32.77,5.4,5.4,0,0,1-.5.71,4.62,4.62,0,0,1-.64.61v.67a.54.54,0,0,1,0,.21.38.38,0,0,1-.14.16l-.93.53a.12.12,0,0,1-.13,0,.18.18,0,0,1-.06-.15v-.7a1.68,1.68,0,0,1-.61.06,1.15,1.15,0,0,1-.47-.17.88.88,0,0,1-.3-.36,1.24,1.24,0,0,1-.11-.52.35.35,0,0,1,0-.17.26.26,0,0,1,.11-.12l.92-.54a.35.35,0,0,1,.16-.06l.11,0,.09.07a.38.38,0,0,0,.15.09.58.58,0,0,0,.24,0,1.19,1.19,0,0,0,.36-.14,3.25,3.25,0,0,0,.63-.48.75.75,0,0,0,.25-.53.19.19,0,0,0-.09-.19.62.62,0,0,0-.28,0,2.49,2.49,0,0,0-.47.12l-.68.2a1.14,1.14,0,0,1-1.07-.08,1.47,1.47,0,0,1-.33-1.11,2.84,2.84,0,0,1,.09-.69,3.24,3.24,0,0,1,.27-.71,3.54,3.54,0,0,1,.42-.69,4.84,4.84,0,0,1,.57-.63v-.7a.45.45,0,0,1,.06-.21.39.39,0,0,1,.13-.15l.93-.54a.12.12,0,0,1,.14,0,.21.21,0,0,1,0,.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.92,294.47a1.45,1.45,0,0,1,.58,0,1,1,0,0,1,.44.18,1,1,0,0,1,.29.34.93.93,0,0,1,.11.44.35.35,0,0,1,0,.17.26.26,0,0,1-.11.12l-.93.54a.21.21,0,0,1-.15,0,.22.22,0,0,1-.13,0l-.07-.05a.32.32,0,0,0-.13-.07h-.21a1.09,1.09,0,0,0-.31.13,2.4,2.4,0,0,0-.26.18,1.42,1.42,0,0,0-.22.2,1,1,0,0,0-.16.24.6.6,0,0,0-.06.27.24.24,0,0,0,.07.19.3.3,0,0,0,.23.05,2.69,2.69,0,0,0,.42-.09l.65-.2a2.86,2.86,0,0,1,.68-.13.83.83,0,0,1,.49.13.79.79,0,0,1,.29.39,2.39,2.39,0,0,1,.09.72,2.69,2.69,0,0,1-.11.79,3.69,3.69,0,0,1-.32.77,4.82,4.82,0,0,1-.49.72,6.15,6.15,0,0,1-.64.61v.67a.42.42,0,0,1-.06.21.36.36,0,0,1-.13.16l-.93.53a.12.12,0,0,1-.14,0s0-.07,0-.14v-.7a1.51,1.51,0,0,1-.62.05,1,1,0,0,1-.46-.17.85.85,0,0,1-.31-.36,1.36,1.36,0,0,1-.11-.51.45.45,0,0,1,0-.18.4.4,0,0,1,.1-.12l.93-.53a.33.33,0,0,1,.15-.06.19.19,0,0,1,.12,0l.08.07.16.09a.61.61,0,0,0,.24,0,.84.84,0,0,0,.35-.14,2.87,2.87,0,0,0,.63-.47.75.75,0,0,0,.25-.54.18.18,0,0,0-.09-.18.49.49,0,0,0-.28,0,2.34,2.34,0,0,0-.47.11l-.67.2a1.11,1.11,0,0,1-1.07-.07,1.43,1.43,0,0,1-.34-1.11,2.84,2.84,0,0,1,.09-.69,4.22,4.22,0,0,1,.27-.72,5.2,5.2,0,0,1,.43-.69,3.68,3.68,0,0,1,.57-.62v-.7a.41.41,0,0,1,.19-.36l.93-.54a.1.1,0,0,1,.13,0,.18.18,0,0,1,.06.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.7,291.71a1.45,1.45,0,0,1,.58,0,1,1,0,0,1,.73.51,1.16,1.16,0,0,1,.12.45.41.41,0,0,1,0,.17.32.32,0,0,1-.1.12l-.93.54a.32.32,0,0,1-.16,0,.24.24,0,0,1-.13,0l-.06-.06-.13-.06h-.22a1.38,1.38,0,0,0-.31.13l-.26.17-.22.21a1.14,1.14,0,0,0-.15.23.66.66,0,0,0-.06.27.23.23,0,0,0,.07.2.33.33,0,0,0,.22.05,2.29,2.29,0,0,0,.42-.09l.66-.2a2.69,2.69,0,0,1,.68-.13.9.9,0,0,1,.48.12.76.76,0,0,1,.29.4,2,2,0,0,1,.1.72,2.71,2.71,0,0,1-.12.79,3.22,3.22,0,0,1-.32.77,3.75,3.75,0,0,1-.49.71,4.69,4.69,0,0,1-.64.62V299a.42.42,0,0,1-.06.21.32.32,0,0,1-.13.15l-.93.54a.1.1,0,0,1-.13,0,.18.18,0,0,1-.06-.15v-.69a1.47,1.47,0,0,1-.61.05,1,1,0,0,1-.47-.17.88.88,0,0,1-.3-.36,1.37,1.37,0,0,1-.12-.51.41.41,0,0,1,0-.18.42.42,0,0,1,.1-.12l.93-.53a.35.35,0,0,1,.16-.06.23.23,0,0,1,.11,0l.09.08a.42.42,0,0,0,.15.08.45.45,0,0,0,.24,0,1,1,0,0,0,.36-.14,2.59,2.59,0,0,0,.62-.47.77.77,0,0,0,.26-.54.17.17,0,0,0-.1-.18.55.55,0,0,0-.27,0,3.25,3.25,0,0,0-.47.12l-.68.2a1.09,1.09,0,0,1-1.07-.08,1.43,1.43,0,0,1-.33-1.1,2.84,2.84,0,0,1,.09-.69,4.16,4.16,0,0,1,.26-.72,4.62,4.62,0,0,1,.43-.69,4.76,4.76,0,0,1,.57-.62v-.7a.42.42,0,0,1,.06-.21.35.35,0,0,1,.13-.16l.93-.53a.1.1,0,0,1,.13,0s.06.07.06.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.26,225.16,72.48,301.24c-.46.27-.83,0-.83-.62a2,2,0,0,1,.83-1.58L204.26,223c.45-.27.82,0,.82.62A2,2,0,0,1,204.26,225.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.26,233,72.48,309.11c-.46.26-.83,0-.83-.63a2,2,0,0,1,.83-1.58l131.78-76.08c.45-.26.82,0,.82.63A2,2,0,0,1,204.26,233Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.26,240.89l-91.45,52.8c-.46.26-.83,0-.83-.63a2,2,0,0,1,.83-1.58l91.45-52.8c.45-.26.82,0,.82.63A2,2,0,0,1,204.26,240.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.28,307.85,72.48,317c-.46.26-.83,0-.83-.63a2,2,0,0,1,.83-1.58l15.8-9.12c.46-.27.83,0,.83.62A2,2,0,0,1,88.28,307.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.26,248.75,72.48,324.83c-.46.27-.83,0-.83-.62a2,2,0,0,1,.83-1.58l131.78-76.08c.45-.27.82,0,.82.62A2,2,0,0,1,204.26,248.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.26,256.62,72.48,332.7c-.46.26-.83,0-.83-.63a2,2,0,0,1,.83-1.58l131.78-76.08c.45-.26.82,0,.82.63A2,2,0,0,1,204.26,256.62Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.26,197.16,72.48,273.24c-.46.26-.83,0-.83-.63a2,2,0,0,1,.83-1.58L204.26,195c.45-.26.82,0,.82.63A2,2,0,0,1,204.26,197.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.26,205,72.48,281.1c-.46.26-.83,0-.83-.63a2,2,0,0,1,.83-1.58l131.78-76.08c.45-.26.82,0,.82.63A2,2,0,0,1,204.26,205Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.26,212.88,72.48,289c-.46.27-.83,0-.83-.62a2,2,0,0,1,.83-1.58l131.78-76.08c.45-.27.82,0,.82.62A2,2,0,0,1,204.26,212.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.26,295.82,153.54,325.1c-.45.27-.82,0-.82-.62a2,2,0,0,1,.82-1.59l50.72-29.27c.45-.27.82,0,.82.62A2,2,0,0,1,204.26,295.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.19,342.62,72.48,371.9c-.46.27-.83,0-.83-.62a2,2,0,0,1,.83-1.58l50.71-29.28c.46-.27.83,0,.83.62A2,2,0,0,1,123.19,342.62Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.59,364.36c4.8-2.66,9.55-7.24,13.61-13a65.65,65.65,0,0,0,5.34-9.05c.79-1.62,1.52-3.29,2.17-5,.49-1.27,1.33-3.28.54-3.92s-2.25.71-3.14,1.65a25.31,25.31,0,0,0-3.24,4.52,89.5,89.5,0,0,0-5.32,10.2,54.66,54.66,0,0,0-3.49,10.61c-.31,1.46-.78,3.48-.12,4.32s2.09,0,3.09-.76c2.84-2.13,5.42-6.17,7.59-9.77a87.06,87.06,0,0,0,6-12c.1-.24,0-.46-.1-.51-.61-.25-1.29.41-1.87,1.29a37.82,37.82,0,0,0-2,3.64,52.05,52.05,0,0,0-3.11,7.79,6.29,6.29,0,0,0-.45,3.09.9.9,0,0,0,1.15.75c1.16-.33,2.38-2.19,3.19-3.62a26.56,26.56,0,0,0,3-8.28c.07-.34-.31-.52-.5-.17a23.71,23.71,0,0,0-2.24,6.35c-.24,1.16-.51,3.4.66,3,.9-.34,1.86-2.18,2.44-3.27a49.24,49.24,0,0,0,2.66-6.52l-.3-.21a39.52,39.52,0,0,0-.83,4c-.12.85-.24,2.1.4,2.2s1.23-1.47,1.53-2.23a40.17,40.17,0,0,0,1.29-4.08l-.36-.17c-.5,1.83-1.41,6.64.87,5.07a11.72,11.72,0,0,0,2.14-2.23c.71-.9,1.41-1.85,2.07-2.84a50.19,50.19,0,0,0,4.94-9.79c.68-1.77,1.29-3.56,1.87-5.36s1.14-3.46,1.59-5.17c.3-1.13.76-2.91.19-3.52s-1.43,1.16-1.84,2c-1.66,3.53-3,7.12-4.33,10.76-1.18,3.24-2.32,6.49-3.18,9.77-.55,2.08-1,4.95.71,4.91,1,0,2-1.5,2.73-2.82.86-1.59,1.64-3.28,2.38-4.95a88.6,88.6,0,0,0,4.3-12c.12-.44-.42-.63-.59-.16-.65,1.87-1.24,3.78-1.73,5.66-.24.94-.45,1.86-.64,2.79a21.22,21.22,0,0,0-.44,2.65c-.06,1,.4,1.74,1.19,1.11,1-.78,1.67-2.75,2-4h-.53a6.73,6.73,0,0,0,.22,2.31c.25.47.63.38,1.12.08a7.12,7.12,0,0,1,2.4-.69l2.46-.5c.42-.08.39-.83,0-.76l-3.54.71a4.48,4.48,0,0,0-1.47.52c-.35.22-.53.18-.61-.29s0-1.06-.07-1.56c0-.22-.42-.46-.53,0a8.59,8.59,0,0,1-1.58,3.47c-1,1.09-.24-2.33-.14-2.87a48.64,48.64,0,0,1,2.4-8.32L113,329a89.9,89.9,0,0,1-3,8.82,67.75,67.75,0,0,1-3.73,8.11c-.58,1-1.55,2.5-2.27,2-.57-.39-.37-1.76-.18-2.75a61.4,61.4,0,0,1,2.13-7.37c1-3,2-6,3.17-8.89q.89-2.24,1.89-4.44a14.08,14.08,0,0,1,1-2.14c.13-.18.45-.4.58-.27a1.33,1.33,0,0,1,0,.41,8.06,8.06,0,0,1-.29,1.48c-.41,1.56-1,3.12-1.46,4.68s-.91,2.88-1.42,4.31a64.33,64.33,0,0,1-3.6,8.46,38.79,38.79,0,0,1-4.48,6.75c-.5.6-1.48,1.83-2,1.73s-.29-1.14-.25-1.71a19.39,19.39,0,0,1,.47-2.81c.08-.31-.25-.58-.36-.17-.23.92-.51,1.84-.83,2.76a11.38,11.38,0,0,1-1.16,2.64c-.47.63-.51.05-.48-.43s.12-1,.18-1.44a24.22,24.22,0,0,1,.56-3.07c.07-.27-.17-.6-.3-.21a54.89,54.89,0,0,1-2.54,5.9,13.39,13.39,0,0,1-2,3.1c-1.18,1.22-.43-2-.24-2.8a21.84,21.84,0,0,1,2-5.16l-.5-.16a26.59,26.59,0,0,1-2.76,7.56c-.57,1.05-2.63,4.47-3.34,3.37-.43-.66.2-2.32.52-3.32.46-1.46,1-2.89,1.59-4.31s1.15-2.54,1.8-3.75c.4-.76,1.85-3.75,2.52-3.48,0-.17-.07-.34-.1-.51a87.15,87.15,0,0,1-4.79,9.86,61.71,61.71,0,0,1-5.85,8.88,13.4,13.4,0,0,1-3.5,3.19c-.57.32-1.35.69-1.55-.08a6.68,6.68,0,0,1,.2-2.42,49.38,49.38,0,0,1,2.91-9.68A81.19,81.19,0,0,1,86,342.31c1.67-3,3.74-6.77,6.15-8.05.46-.25.81,0,.67.7a7.72,7.72,0,0,1-.36,1.22c-.28.75-.57,1.49-.87,2.23-.61,1.48-1.28,2.94-2,4.36A62.44,62.44,0,0,1,84.76,351c-3.93,5.59-8.53,10.17-13.19,13-.17.11-.14.53,0,.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.16,310.84c-.64,1.19-1.88,3.32-2.81,2.91s-.07-2.71.3-3.81a38.38,38.38,0,0,1,4.5-8.65,37.18,37.18,0,0,1,2.79-3.72,10.66,10.66,0,0,1,2.95-2.76c2.15-.93-1.38,7.39-1.87,8.67-1.54,4-3.1,7.95-4.63,11.93-.3.78.42.81.75.22,1.17-2.12,2.35-4.22,3.51-6.34s2.14-4,3.36-5.81l-.65-.06c-.08,1.37-.61,2.84-.82,4.25-.16,1-.24,2.4.57,2.31.63-.07,1.16-1,1.54-1.83.76-1.52,1.49-3.06,2.23-4.59l-.69-.08c-.15,1.26-.39,2.6-.45,3.82,0,.67.11,1.29.59,1.31s1.27-1,1.7-1.78a9.49,9.49,0,0,0,1-2.82c.1-.55-.52-.61-.7,0a15.06,15.06,0,0,0-.64,3.68c0,.77.34,1.11.9.88,1.35-.54,2.61-2.74,3.52-4.39,1-1.85,2-3.71,2.93-5.64a23.51,23.51,0,0,0,1.23-2.88,4,4,0,0,0,.31-2.25c-.67-1.61-3,3.83-3.45,4.72a32.9,32.9,0,0,0-1.6,4.24,25.14,25.14,0,0,0-.81,3.52c-.11.69-.14,1.43.22,1.74,1.06.93,3.09-2.89,3.79-4.3,1.29-2.61,2.48-5.33,3.56-8l-.65-.13c-.4,1.32-.77,2.63-1,3.95-.18.87-.57,2.25,0,2.61s1-.57,1.43-1.28a15.84,15.84,0,0,0,1.43-3.89l-.52-.12a21.25,21.25,0,0,0-.31,2.56c0,.44.13.79.44.8.85,0,1.43-1.8,1.64-2.76l-.44.22c.38.41.76.92,1.32.95a3.19,3.19,0,0,0,2.1-1.26,21.81,21.81,0,0,0,2.21-3.08c.65-1,1.28-2.1,1.88-3.19a66.81,66.81,0,0,0,5.74-14c.14-.47-.41-.65-.61-.17-3.95,9.12-6.66,18.63-10,27.91q-1.44,4.05-3.09,8l.74.16A49,49,0,0,1,187,306c1.08-2.32,2.28-4.58,3.48-6.81q3.61-6.66,7.5-13.08c1.48-2.43,3-4.86,4.45-7.27.35-.55-.23-.91-.54-.42A300,300,0,0,0,187.14,305a49.36,49.36,0,0,0-3.38,7.63c-.18.59.5.73.74.17,3.82-9.18,6.39-18.64,9.76-27.93,1-2.72,2.05-5.38,3.21-8l-.62-.16A66.43,66.43,0,0,1,191.92,289a59.12,59.12,0,0,1-3.47,5.84,7.21,7.21,0,0,1-2.34,2.48c-.72.33-1.1-.27-1.5-.74-.08-.1-.37-.07-.44.22s-.56,2.18-.9,2,.14-1.94.19-2.38-.4-.6-.52-.13A17.33,17.33,0,0,1,182,299c-.15.35-.31.69-.48,1s-.56,1.22-.59.52a10.24,10.24,0,0,1,.57-2.66c.25-.87.54-1.74.83-2.6.18-.55-.37-.81-.61-.25-.83,1.94-1.66,3.87-2.55,5.78a35.67,35.67,0,0,1-2.3,4.43c-.3.46-1.46,2.19-1.46,1.14a12.09,12.09,0,0,1,.47-2.68,27,27,0,0,1,1.45-4.43,29.8,29.8,0,0,1,2.53-4.9,3.43,3.43,0,0,0,.24-.33c0,.06.09-.08.06-.06-.2.1-.14.14-.2.39a14.87,14.87,0,0,1-.76,2.28c-.68,1.57-1.45,3.12-2.24,4.63a36.4,36.4,0,0,1-2.9,5,6.47,6.47,0,0,1-.91,1,3.13,3.13,0,0,1-.42.34c-.32.19-.34.09-.34-.35a13.8,13.8,0,0,1,.68-3.33h-.7a8,8,0,0,1-.59,1.86c-.17.36-.93,1.85-1.21,1.79s0-1.45.06-1.77l.3-2.45c.06-.52-.45-.59-.7-.08l-1.65,3.41c-.19.4-.86,2.08-1.21,2.23-.54.22.08-2.38.19-2.81a22.91,22.91,0,0,0,.55-2.94c0-.46-.36-.6-.65-.18-1.27,1.86-2.37,3.9-3.49,5.92s-2.38,4.28-3.57,6.42l.75.22q2.64-6.7,5.22-13.42c.86-2.24,3.88-9.41.8-8.52-1.12.32-2.33,1.67-3.35,2.81a39.55,39.55,0,0,0-3.44,4.55c-2,3.06-4.17,6.81-5,10.49-.38,1.68-.28,3.34.94,3.29s2.56-1.86,3.43-3.65c.24-.48-.32-.79-.56-.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.85,100.35a.51.51,0,0,1-.26-1L205.19,80a.51.51,0,0,1,.7.18.52.52,0,0,1-.19.71l-33.59,19.39A.51.51,0,0,1,171.85,100.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.85,104.18a.51.51,0,0,1-.26-1l33.6-19.4a.52.52,0,0,1,.7.19.51.51,0,0,1-.19.7l-33.59,19.4A.51.51,0,0,1,171.85,104.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.85,108a.53.53,0,0,1-.45-.25.52.52,0,0,1,.19-.7l33.6-19.4a.51.51,0,1,1,.51.89l-33.59,19.4A.62.62,0,0,1,171.85,108Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "72.41 157.3 69.11 159.21 69.11 157.9 72.41 155.99 72.41 157.3",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "72.41 166.01 69.11 167.91 69.11 166.6 72.41 164.7 72.41 166.01",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "72.09 164.63 69.42 166.17 69.42 159.25 72.09 157.71 72.09 164.63",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.92 154.12 74.62 156.02 74.62 154.72 77.92 152.81 77.92 154.12",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.92 162.82 74.62 164.73 74.62 163.42 77.92 161.52 77.92 162.82",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.61 161.45 74.94 162.99 74.94 156.07 77.61 154.53 77.61 161.45",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.43 150.94 80.13 152.84 80.13 151.53 83.43 149.63 83.43 150.94",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.43 159.64 80.13 161.55 80.13 160.24 83.43 158.34 83.43 159.64",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.11 158.27 80.45 159.81 80.45 152.88 83.11 151.34 83.11 158.27",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.05,148.49l-15.56,9a.52.52,0,0,0-.2.4h0c0,.15.09.22.2.16l15.56-9a.52.52,0,0,0,.2-.4h0C84.25,148.5,84.16,148.43,84.05,148.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.05,147.13,67.49,157.27a.5.5,0,0,0-.21.4h0c0,.15.09.22.21.16l17.56-10.15a.47.47,0,0,0,.21-.39h0C85.26,147.14,85.17,147.07,85.05,147.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.49,169.05l15.56-9a.51.51,0,0,0,.2-.4h0c0-.15-.09-.22-.2-.15l-15.56,9a.52.52,0,0,0-.2.4h0C68.29,169,68.38,169.11,68.49,169.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.49,170.41l17.56-10.14a.49.49,0,0,0,.21-.4h0c0-.15-.09-.22-.21-.15L67.49,169.86a.47.47,0,0,0-.21.39h0C67.28,170.41,67.37,170.48,67.49,170.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4,171.82l19.74-11.4a.49.49,0,0,0,.2-.39h0c0-.15-.09-.23-.2-.16L66.4,171.26a.53.53,0,0,0-.21.4h0C66.19,171.81,66.29,171.88,66.4,171.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76,145.11l-7.14,10.61a.24.24,0,0,0,.32.34l14.54-8.39a.27.27,0,0,0,0-.49l-7-2.31A.6.6,0,0,0,76,145.11Zm-5.18,9.08,5.57-8.29L82,147.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.59,147.84a.5.5,0,0,1-.44-.25.51.51,0,0,1,.18-.7l33.6-19.4a.5.5,0,0,1,.7.19.51.51,0,0,1-.19.7L89.85,147.77A.48.48,0,0,1,89.59,147.84Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.59,151.67a.49.49,0,0,1-.44-.26.51.51,0,0,1,.18-.7l33.6-19.4a.52.52,0,0,1,.7.19.51.51,0,0,1-.19.7L89.85,151.6A.48.48,0,0,1,89.59,151.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.59,155.5a.52.52,0,0,1-.26-1l19.3-11.14a.51.51,0,1,1,.51.89L89.85,155.43A.59.59,0,0,1,89.59,155.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.32,288.47v-3.16c-7,4-12.7,14.92-12.7,24.25l2.38-1.37C169,300.6,173.63,291.76,179.32,288.47Zm9.14,8.48c0-6.73-4.1-9.83-9.14-6.92s-9.15,10.75-9.15,17.48,4.1,9.83,9.15,6.92S188.46,303.67,188.46,297Zm-17.11,9.87c0-5.85,3.58-12.67,8-15.21a9.44,9.44,0,0,1,.9-.45L171.41,308C171.38,307.62,171.35,307.23,171.35,306.82Zm.35,2.87,9.91-18.95c2.57-.45,4.59,1.1,5.34,4.1l-9.87,18.86C174.51,314.18,172.47,312.66,171.7,309.69Zm15.53-13.15c0,.35.05.71.05,1.09,0,5.86-3.58,12.68-8,15.21a8.38,8.38,0,0,1-.84.43Zm-7.91-14.38c-8.3,4.8-15,17.69-15,28.76s6.75,16.16,15,11.37,15-17.69,15-28.75S187.61,277.37,179.32,282.16Zm0,38.55c-7.65,4.41-13.87-.29-13.87-10.48s6.22-22.07,13.87-26.48,13.86.28,13.86,10.48S187,316.3,179.32,320.71Zm10.31-24.44c0,7.59-4.63,16.43-10.31,19.72v3.16c7-4,12.69-14.92,12.69-24.25Z",
    style: {
      fill: "#76ABAE",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clip--inject-136"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--shadow--inject-136",
    style: {
      opacity: 0.25
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M179.31,70.23V83.31a11.23,11.23,0,0,1-5.12,8.88L148.87,106.8c-1.25.72-2,2.16-2.71,3.68a14.54,14.54,0,0,1-2,3.2c-2,2.23-6.25,4.55-9.28,5.52a18,18,0,0,1-3,.7l-1.24.17c-2.76.37-6.2.84-8.22,2L92.8,139.17a5.15,5.15,0,0,1-2.58.77,3.4,3.4,0,0,1-1.73-.44,4.25,4.25,0,0,1-1.88-3.9V122.53a11.17,11.17,0,0,1,5.13-8.88l10-5.75a.46.46,0,0,1,.14-.05,1,1,0,0,1,1,1.8.47.47,0,0,1-.12.09l-10,5.75a9.15,9.15,0,0,0-4.07,7V135.6a1.79,1.79,0,0,0,3,1.73l29.62-17.1c2.38-1.37,6-1.87,9-2.26l1.23-.17a16.29,16.29,0,0,0,2.69-.63c2.69-.85,6.68-3,8.33-4.9a12.5,12.5,0,0,0,1.64-2.73c.86-1.75,1.76-3.54,3.56-4.58l25.31-14.61a9.17,9.17,0,0,0,4.07-7V70.23a2.28,2.28,0,0,0-.82-2,2.25,2.25,0,0,0-2.18.32l-8.63,5a8.64,8.64,0,0,0-1.08-1.83l8.64-5a3.84,3.84,0,0,1,6.19,3.57Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--clip--inject-136"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.85,70.47h0a2.64,2.64,0,0,1,2.67.25,8.32,8.32,0,0,1,3.77,6.52,2.64,2.64,0,0,1-1.12,2.44h0l-60,34.68-5.32-9.22Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.47,109.78l62.72-36.22a7.6,7.6,0,0,0-2.67-2.83c-.12-.07-.24-.11-.36-.17l-61.75,35.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.47,105.41c-2.08-1.2-3.76-.23-3.76,2.17a8.31,8.31,0,0,0,3.76,6.52c2.08,1.2,3.76.23,3.76-2.17A8.31,8.31,0,0,0,103.47,105.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.38,71.16V84.24a11.21,11.21,0,0,1-5.13,8.88l-25.31,14.61c-1.25.72-2,2.16-2.72,3.68a14.13,14.13,0,0,1-1.95,3.2c-2,2.23-6.26,4.55-9.28,5.52a18,18,0,0,1-3,.7l-1.24.17c-2.76.37-6.2.84-8.22,2L93.87,140.1a5.2,5.2,0,0,1-2.58.78,3.41,3.41,0,0,1-1.73-.45,4.25,4.25,0,0,1-1.88-3.9V123.46a11.17,11.17,0,0,1,5.13-8.88l9.94-5.75.14,0a1,1,0,0,1,1,1.8.31.31,0,0,1-.11.09l-9.95,5.75a9.15,9.15,0,0,0-4.07,7v13.07a1.79,1.79,0,0,0,3,1.73l29.62-17.1c2.38-1.37,6-1.87,9-2.26l1.23-.17a16.4,16.4,0,0,0,2.7-.63c2.69-.85,6.68-3,8.33-4.9a12.9,12.9,0,0,0,1.64-2.73c.86-1.75,1.75-3.54,3.56-4.58l25.31-14.61a9.17,9.17,0,0,0,4.07-7V71.16a1.79,1.79,0,0,0-3-1.73l-8.62,5a9.2,9.2,0,0,0-1.08-1.82l8.64-5a3.84,3.84,0,0,1,6.19,3.57Z",
    style: {
      fill: "#455a64"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Stamp--inject-136"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--stamp--inject-136"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.32,186.78c.75-.68,1.51-.51,1.69.39l3.36,16.2a3.38,3.38,0,0,1-1,2.86l-79,71.58c-.75.68-1.51.51-1.69-.38l-3.37-16.21a3.41,3.41,0,0,1,1-2.85l79-71.59M177,185.2,98,256.79a6.68,6.68,0,0,0-2,5.63l3.36,16.21c.36,1.77,1.86,2.11,3.35.77l79-71.59a6.7,6.7,0,0,0,2-5.64L180.34,186c-.37-1.77-1.87-2.11-3.35-.76Z",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.74,254.91c.17-.15.3-.21.41-.18a.44.44,0,0,1,.25.16l4.62,6.83a.47.47,0,0,1,.09.17.53.53,0,0,1,0,.3.6.6,0,0,1-.17.27l-1.56,1.42c-.17.15-.29.21-.38.19a.23.23,0,0,1-.18-.13l-.6-.9-3.29,3-.09,1.53a.91.91,0,0,1-.08.36,1.14,1.14,0,0,1-.32.45l-1.56,1.41a.26.26,0,0,1-.21.08.19.19,0,0,1-.13-.16,1.08,1.08,0,0,1,0-.26l.78-11.72a1.63,1.63,0,0,1,.11-.48,1.21,1.21,0,0,1,.34-.51Zm-.67,8.24,2-1.81-1.74-2.63Z",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.53,246.94a7.08,7.08,0,0,1,1.47-1.07,2.33,2.33,0,0,1,1.21-.33,1.26,1.26,0,0,1,.91.46,2.77,2.77,0,0,1,.55,1.28,5.36,5.36,0,0,1,.07,1.74,6.07,6.07,0,0,1-.46,1.69,7.83,7.83,0,0,1-.94,1.62,10.2,10.2,0,0,1-1.38,1.51l-1.58,1.44.62,3a.7.7,0,0,1,0,.37.78.78,0,0,1-.21.33l-1.62,1.47a.29.29,0,0,1-.26.09.21.21,0,0,1-.15-.19l-2-9.51a.68.68,0,0,1,.05-.36.7.7,0,0,1,.21-.34Zm-.63,6,1.52-1.38a3.37,3.37,0,0,0,.81-1,1.84,1.84,0,0,0,.15-1.2c-.08-.41-.26-.6-.52-.58a1.72,1.72,0,0,0-.92.51l-1.52,1.38Z",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.63,238.69a7.56,7.56,0,0,1,1.46-1.07,2.36,2.36,0,0,1,1.21-.33,1.28,1.28,0,0,1,.91.46,2.77,2.77,0,0,1,.55,1.28,5.36,5.36,0,0,1,.08,1.74,6.16,6.16,0,0,1-.47,1.7,7.9,7.9,0,0,1-.94,1.62,10.11,10.11,0,0,1-1.37,1.51L125.48,247l.62,3a.7.7,0,0,1,0,.37.78.78,0,0,1-.21.33l-1.62,1.47a.33.33,0,0,1-.26.1.23.23,0,0,1-.16-.19l-2-9.51a.7.7,0,0,1,0-.37.78.78,0,0,1,.21-.33Zm-.63,6.05,1.52-1.38a3.58,3.58,0,0,0,.8-1.05,1.86,1.86,0,0,0,.16-1.2c-.09-.41-.26-.61-.53-.58a1.67,1.67,0,0,0-.91.5l-1.52,1.38Z",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.54,230.62a7.63,7.63,0,0,1,1.5-1.12,2.48,2.48,0,0,1,1.22-.37,1.17,1.17,0,0,1,.91.42,2.77,2.77,0,0,1,.55,1.28,5.17,5.17,0,0,1,0,2.18,6.8,6.8,0,0,1-.86,2.09l2.26,2.12a.21.21,0,0,1,.07.12.58.58,0,0,1,0,.31.62.62,0,0,1-.17.26l-1.68,1.53c-.17.15-.3.21-.38.19a.71.71,0,0,1-.23-.12l-2-1.9-1.14,1,.66,3.15a.73.73,0,0,1,0,.37.93.93,0,0,1-.21.33L133.32,244a.26.26,0,0,1-.25.1.2.2,0,0,1-.16-.19l-2-9.51a.7.7,0,0,1,0-.37.78.78,0,0,1,.21-.33Zm-.47,5.72,1.39-1.27a3.6,3.6,0,0,0,.81-1,1.66,1.66,0,0,0,.17-1.16c-.09-.41-.26-.6-.52-.55a2,2,0,0,0-.91.55l-1.4,1.26Z",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.57,229.71a7,7,0,0,1,0-1.83,7.75,7.75,0,0,1,.49-1.95,9.83,9.83,0,0,1,2.55-3.71,6.4,6.4,0,0,1,1.68-1.14,2.62,2.62,0,0,1,1.37-.23,1.65,1.65,0,0,1,1,.59,3.13,3.13,0,0,1,.63,1.28c.1.4.2.84.3,1.3s.17.9.24,1.31a6.57,6.57,0,0,1,0,1.83,8.4,8.4,0,0,1-.49,2,9.2,9.2,0,0,1-1,1.93,9.78,9.78,0,0,1-1.54,1.77,6.15,6.15,0,0,1-1.68,1.15,2.38,2.38,0,0,1-1.36.22,1.63,1.63,0,0,1-1-.59,3.15,3.15,0,0,1-.62-1.27c-.1-.39-.2-.81-.3-1.28S140.65,230.14,140.57,229.71Zm6-2.38c0-.18-.06-.38-.1-.61l-.12-.67c-.05-.23-.1-.44-.15-.64s-.1-.39-.14-.55a1.72,1.72,0,0,0-.27-.56.78.78,0,0,0-.41-.27,1,1,0,0,0-.55.07,2.74,2.74,0,0,0-.7.48,3.94,3.94,0,0,0-.64.73,4.27,4.27,0,0,0-.4.8,2.81,2.81,0,0,0-.18.8,3.06,3.06,0,0,0,0,.8,4.59,4.59,0,0,0,.08.59c0,.22.09.44.13.66s.1.45.15.66a4.94,4.94,0,0,0,.15.56,1.1,1.1,0,0,0,.68.84c.32.09.73-.09,1.24-.56a3.52,3.52,0,0,0,1-1.51A3.79,3.79,0,0,0,146.53,227.33Z",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154,225.19q-.48.44-.78,0l-4.43-6.91-.06-.11s0,0,0,0a.66.66,0,0,1,0-.3.62.62,0,0,1,.17-.27l1.56-1.41c.16-.15.29-.21.37-.19a.24.24,0,0,1,.18.12l3.07,4.92.37-8a1.24,1.24,0,0,1,.08-.37,1.12,1.12,0,0,1,.33-.44l1.55-1.41a.26.26,0,0,1,.21-.08.19.19,0,0,1,.13.16.13.13,0,0,1,0,.06V211l-.62,11.49a1.67,1.67,0,0,1-.53,1.18Z",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.33,211.24a.28.28,0,0,1,.26-.1c.08,0,.13.08.16.19l.32,1.56a.7.7,0,0,1,0,.37.78.78,0,0,1-.21.33L161,218.9a.3.3,0,0,1-.26.1.24.24,0,0,1-.16-.19l-2-9.51a.7.7,0,0,1,0-.37.78.78,0,0,1,.21-.33l5.76-5.22a.3.3,0,0,1,.26-.1.2.2,0,0,1,.16.19l.32,1.56a.62.62,0,0,1,0,.37.78.78,0,0,1-.21.33l-3.8,3.45.32,1.59,3.54-3.2a.3.3,0,0,1,.26-.1.24.24,0,0,1,.16.19l.32,1.56a.7.7,0,0,1,0,.37.78.78,0,0,1-.21.33l-3.54,3.21.34,1.65Z",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.66,197.86a6.52,6.52,0,0,1,1.62-1.11,2.75,2.75,0,0,1,1.4-.25,1.69,1.69,0,0,1,1.07.57,3.15,3.15,0,0,1,.67,1.36c.05.2.1.38.13.56l.1.49.1.49c0,.16.07.35.1.55a6.75,6.75,0,0,1,0,2,8.55,8.55,0,0,1-.52,2,9.67,9.67,0,0,1-1,1.93,9.17,9.17,0,0,1-1.48,1.7l-3.33,3a.3.3,0,0,1-.26.09.2.2,0,0,1-.16-.19l-2-9.51a.67.67,0,0,1,0-.36.89.89,0,0,1,.21-.34Zm2.46,2.58c-.28-1.08-1-1.14-2-.16l-1.26,1.14L171,207l1.32-1.2a3.37,3.37,0,0,0,1.27-3.16c0-.21-.07-.41-.11-.59s-.07-.36-.11-.53l-.11-.52C173.22,200.83,173.17,200.64,173.12,200.44Z",
    style: {
      fill: "#76ABAE"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-136"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-136"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67,433.36l8.32-4.8s5-20.57,3-39.08c-2.78-26-19.91-35.82-26.42-33.58s-8.4,9.82,2.38,25.32C60.65,390.37,68.46,409.41,67,433.36Z",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.65
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67,433.36l8.32-4.8s5-20.57,3-39.08c-2.78-26-19.91-35.82-26.42-33.58s-8.4,9.82,2.38,25.32C60.65,390.37,68.46,409.41,67,433.36Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M70.48,423.26H70.4a.57.57,0,0,1-.46-.68c4.56-24-3.83-51-14.21-62.2a.57.57,0,0,1,0-.81.59.59,0,0,1,.82,0C67.15,371,75.7,398.43,71.07,422.79A.58.58,0,0,1,70.48,423.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1,445.45c-1.25.63-4.55-2.2-5.47-2.88A11.54,11.54,0,0,1,37,438a10.82,10.82,0,0,1-.64-6.53,25.57,25.57,0,0,1,1-3.41l1.13-3.3a8.48,8.48,0,0,0,.66-3.35c-.18-2.31-2.13-4-3.91-5.49-2-1.63-4-3.76-3.84-6.52a9.74,9.74,0,0,1,2.72-5.64c1.4-1.61,3-3,4.32-4.71a6.79,6.79,0,0,0,1.61-4.21,7.12,7.12,0,0,0-.8-2.72c-.88-1.85-2.09-3.56-2.66-5.52s-.36-4.35,1.22-5.66c1.29-1.07,3.13-1.13,4.8-.94A10.88,10.88,0,0,1,47,381.75c4.26,2.65,6.49,8,11,10.07a47.91,47.91,0,0,0,5.55,1.66,6.91,6.91,0,0,1,4.48,3.4c1.53,3.49-1.84,7.53-.83,11.21.9,3.25,4,4.63,5.55,7.6a6.82,6.82,0,0,1,.6,4.23,20,20,0,0,1-2.12,7,62.45,62.45,0,0,1-4.2,6.46Z",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.1,445.45c-1.25.63-4.55-2.2-5.47-2.88A11.54,11.54,0,0,1,37,438a10.82,10.82,0,0,1-.64-6.53,25.57,25.57,0,0,1,1-3.41l1.13-3.3a8.48,8.48,0,0,0,.66-3.35c-.18-2.31-2.13-4-3.91-5.49-2-1.63-4-3.76-3.84-6.52a9.74,9.74,0,0,1,2.72-5.64c1.4-1.61,3-3,4.32-4.71a6.79,6.79,0,0,0,1.61-4.21,7.12,7.12,0,0,0-.8-2.72c-.88-1.85-2.09-3.56-2.66-5.52s-.36-4.35,1.22-5.66c1.29-1.07,3.13-1.13,4.8-.94A10.88,10.88,0,0,1,47,381.75c4.26,2.65,6.49,8,11,10.07a47.91,47.91,0,0,0,5.55,1.66,6.91,6.91,0,0,1,4.48,3.4c1.53,3.49-1.84,7.53-.83,11.21.9,3.25,4,4.63,5.55,7.6a6.82,6.82,0,0,1,.6,4.23,20,20,0,0,1-2.12,7,62.45,62.45,0,0,1-4.2,6.46Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M58.14,439.17h0a.54.54,0,0,1-.5-.59c2-21.59-7-46-14.06-53.3a.55.55,0,0,1,0-.77.54.54,0,0,1,.77,0c7.21,7.46,16.39,32.27,14.37,54.16A.54.54,0,0,1,58.14,439.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56,412.55a.45.45,0,0,1-.16,0,73.2,73.2,0,0,0-15.57-3.32.54.54,0,0,1-.49-.59.53.53,0,0,1,.59-.5,74.72,74.72,0,0,1,15.85,3.39.54.54,0,0,1,.32.7A.53.53,0,0,1,56,412.55Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Banknotes--inject-136"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Money--inject-136"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "107.41 395.91 243.78 317.42 311.95 356.66 175.59 435.15 107.41 395.91",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.41 395.91 243.78 317.42 311.95 356.66 175.59 435.15 107.41 395.91",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.77,321.55,114.58,395.9l61,35.12,129.19-74.36ZM175.59,429,118.17,395.9l125.6-72.29,57.42,33.05Z",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.26,391.27c-6.11-3.51-9.47-8.31-9.47-13.52,0-5.68,4.11-11.3,11.26-15.42,14-8.07,36-8.53,49.06-1,6.1,3.51,9.46,8.32,9.46,13.52,0,5.68-4.1,11.3-11.26,15.42h0c-7.34,4.23-16.88,6.37-26.18,6.37C198.7,396.61,190.46,394.84,184.26,391.27Zm2.4-27.88c-6.77,3.89-10.65,9.13-10.65,14.36,0,4.75,3.15,9.18,8.86,12.47,12.69,7.31,34.15,6.84,47.83-1h0c6.77-3.9,10.65-9.13,10.65-14.37,0-4.75-3.14-9.18-8.85-12.47-6-3.47-14.05-5.19-22.27-5.19C203.16,357.16,193.84,359.26,186.66,363.39Z",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.47,387.46c-4.68-2.69-7.26-6.14-7.26-9.71,0-4.06,3.3-8.29,9-11.6,6.4-3.69,15.14-5.8,24-5.8,8,0,15.33,1.69,20.67,4.76,4.68,2.7,7.25,6.15,7.25,9.71,0,4.07-3.29,8.29-9.05,11.61-6.4,3.68-15.13,5.79-24,5.79C199.14,392.22,191.8,390.53,186.47,387.46Z",
    style: {
      fill: "#76ABAE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M178.88,419.45a7.33,7.33,0,0,0-6.58,0l-3.89,2.24L131,400.31l4.51-2.59a2,2,0,0,0,1.19-1.55c0-.55-.43-1.09-1.19-1.53L131,392l41.05-23.75-.8,1.74a15.92,15.92,0,0,0-1.52,6.71c0,6.65,6.69,13.48,13.33,17.3a57,57,0,0,0,26.08,6.85,64,64,0,0,0,8.08-.52l3-.38-37.48,21.7Z",
    style: {
      fill: "#76ABAE",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.77,405.24a4.17,4.17,0,0,1-2.41-3.52c0-1.48,1-2.92,2.82-4,3.36-1.94,8.63-2,11.76-.24a4.16,4.16,0,0,1,2.41,3.52c0,1.48-1,2.92-2.82,3.95a12.89,12.89,0,0,1-6.26,1.52A11.23,11.23,0,0,1,160.77,405.24Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M248,382.51a23.2,23.2,0,0,0,1.57-8.17c0-5.54-4.37-10.87-13-15.83-6.91-4-17.52-6.66-26.4-6.66a63.78,63.78,0,0,0-8.09.52l-3,.39,37.48-21.51,3.88,2.25a7.44,7.44,0,0,0,6.57,0l3.89-2.25,37.32,21.2-4.5,2.6c-.76.44-1.18,1-1.18,1.53a2,2,0,0,0,1.18,1.54l4.5,2.59-41,23.53Z",
    style: {
      fill: "#76ABAE",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.58,356a4.18,4.18,0,0,1-2.41-3.52c0-1.48,1-2.92,2.83-3.95,3.35-1.93,8.63-2,11.75-.24a4.18,4.18,0,0,1,2.42,3.52c0,1.48-1,2.92-2.83,3.95h0a12.83,12.83,0,0,1-6.26,1.52A11.26,11.26,0,0,1,246.58,356Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "107.41 395.91 107.41 412.43 175.59 451.68 175.59 435.15 107.41 395.91",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "107.41 395.91 107.41 412.43 175.59 451.68 175.59 435.15 107.41 395.91",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "175.59 438.83 154.06 426.89 175.59 439.84 175.59 438.83"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "107.41 403.75 114.59 408.3 107.41 404.59 107.41 403.75"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "107.41 407.69 143.29 428.95 107.41 408.91 107.41 407.69"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "175.59 442.77 139.71 422.76 175.59 444.07 175.59 442.77"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "175.59 451.68 311.95 373.19 311.95 356.66 175.59 435.15 175.59 451.68",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "175.59 451.68 311.95 373.19 311.95 356.66 175.59 435.15 175.59 451.68"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "175.59 438.83 182.78 435.15 175.59 439.84 175.59 438.83"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "175.59 442.77 211.67 422.66 175.59 444.07 175.59 442.77"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "311.95 364.44 286.83 379.38 311.95 365.41 311.95 364.44"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "311.96 368.59 297.6 377.32 311.95 369.52 311.96 368.59"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "163.71 360.76 234.27 401.38 255.79 388.99 185.24 348.36 163.71 360.76",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.79 388.99 255.79 406.97 234.27 419.36 234.27 401.38 255.79 388.99",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "234.27 419.36 233.01 418.63 234.27 417.9 234.27 419.36",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.71 360.76 163.71 363.5 166.09 362.13 163.71 360.76",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    points: "233.01 418.62 233.01 402.11 234.27 401.38 234.27 417.9 233.01 418.62"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply",
      opacity: 0.2
    }
  }, _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
    points: "233.01 402.11 164.83 362.86 166.09 362.13 234.27 401.38 233.01 402.11"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "166.03 359.42 236.6 400.04 238.39 399 167.83 358.39 166.03 359.42",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "181.11 350.75 251.68 391.36 253.47 390.33 182.91 349.72 181.11 350.75",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "236.6 400.04 236.6 418.02 238.39 416.99 238.39 399 236.6 400.04",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "251.68 391.36 251.68 409.34 253.47 408.3 253.47 390.33 251.68 391.36",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--money--inject-136"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "87.83 379.34 224.2 300.85 292.38 340.1 156.01 418.59 87.83 379.34",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.83 379.34 224.2 300.85 292.38 340.1 156.01 418.59 87.83 379.34",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.2,305,95,379.34l61,35.12L285.2,340.1ZM156,412.39,98.6,379.34l125.6-72.29,57.41,33.05Z",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.68,374.71c-6.1-3.51-9.46-8.32-9.46-13.52,0-5.68,4.1-11.3,11.25-15.42,14-8.07,36-8.53,49.06-1,6.1,3.51,9.47,8.31,9.47,13.52,0,5.68-4.11,11.3-11.26,15.42h0c-7.35,4.23-16.89,6.37-26.18,6.37C179.12,380.05,170.88,378.28,164.68,374.71Zm2.41-27.89c-6.77,3.9-10.65,9.14-10.65,14.37,0,4.75,3.14,9.18,8.85,12.47,12.69,7.3,34.15,6.84,47.83-1h0c6.77-3.89,10.65-9.13,10.65-14.36,0-4.75-3.14-9.18-8.85-12.47-6-3.47-14-5.19-22.27-5.19C183.58,340.6,174.26,342.69,167.09,346.82Z",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.89,370.89c-4.68-2.69-7.26-6.14-7.26-9.7,0-4.07,3.3-8.3,9.05-11.61,6.4-3.68,15.14-5.79,24-5.79,8,0,15.34,1.69,20.67,4.76,4.68,2.69,7.26,6.14,7.26,9.71,0,4.06-3.3,8.29-9.05,11.6-6.4,3.69-15.14,5.8-24,5.8C179.57,375.66,172.22,374,166.89,370.89Z",
    style: {
      fill: "#76ABAE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M159.3,402.88a7.31,7.31,0,0,0-6.57,0l-3.89,2.24-37.39-21.39,4.5-2.59c.77-.44,1.19-1,1.19-1.54a1.93,1.93,0,0,0-1.19-1.53l-4.5-2.6,41.05-23.76-.8,1.75a15.91,15.91,0,0,0-1.52,6.7c0,6.66,6.7,13.49,13.33,17.31a57.15,57.15,0,0,0,26.08,6.84,64,64,0,0,0,8.08-.51l3-.39-37.49,21.71Z",
    style: {
      fill: "#76ABAE",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.19,388.67a4.17,4.17,0,0,1-2.41-3.51c0-1.48,1-2.92,2.83-4,3.35-1.93,8.63-2,11.75-.23a4.16,4.16,0,0,1,2.42,3.51c0,1.48-1,2.92-2.83,4a12.89,12.89,0,0,1-6.26,1.52A11.23,11.23,0,0,1,141.19,388.67Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M228.4,366a23.21,23.21,0,0,0,1.58-8.17c0-5.54-4.38-10.87-13-15.84-6.91-4-17.52-6.65-26.4-6.65a63.78,63.78,0,0,0-8.09.51l-3,.39,37.48-21.5,3.89,2.24a7.38,7.38,0,0,0,6.56,0l3.89-2.25,37.33,21.19-4.51,2.61A1.94,1.94,0,0,0,262.9,340a2,2,0,0,0,1.18,1.54l4.5,2.59-41,23.53Z",
    style: {
      fill: "#76ABAE",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M227,339.48a4.18,4.18,0,0,1-2.42-3.52c0-1.48,1-2.92,2.83-3.95,3.35-1.94,8.63-2,11.76-.24a4.17,4.17,0,0,1,2.41,3.51c0,1.48-1,2.92-2.83,4h0a12.83,12.83,0,0,1-6.26,1.52A11.22,11.22,0,0,1,227,339.48Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "87.83 379.34 87.83 395.87 156.01 435.11 156.01 418.59 87.83 379.34",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "87.83 379.34 87.83 395.87 156.01 435.11 156.01 418.59 87.83 379.34",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "156.01 422.27 134.48 410.33 156.02 423.27 156.01 422.27"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "87.83 387.19 95.01 391.74 87.84 388.03 87.83 387.19"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "87.83 391.13 123.71 412.39 87.83 392.35 87.83 391.13"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "156.02 426.2 120.13 406.2 156.02 427.5 156.02 426.2"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "156.01 435.11 292.38 356.63 292.38 340.1 156.01 418.59 156.01 435.11",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "156.01 435.11 292.38 356.63 292.38 340.1 156.01 418.59 156.01 435.11"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    points: "156.01 422.27 163.2 418.59 156.02 423.27 156.01 422.27"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    points: "156.02 426.2 192.1 406.1 156.02 427.5 156.02 426.2"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    points: "292.38 347.88 267.26 362.82 292.38 348.85 292.38 347.88"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    points: "292.38 352.03 278.02 360.76 292.38 352.96 292.38 352.03"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "144.14 344.19 214.69 384.81 236.22 372.43 165.67 331.8 144.14 344.19",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "236.22 372.43 236.22 390.4 214.69 402.79 214.69 384.81 236.22 372.43",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.69 402.79 213.43 402.06 214.69 401.34 214.69 402.79",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "144.14 344.19 144.14 346.94 146.52 345.56 144.14 344.19",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    points: "213.43 402.06 213.43 385.54 214.69 384.81 214.69 401.33 213.43 402.06"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply",
      opacity: 0.2
    }
  }, _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    points: "213.43 385.54 145.26 346.29 146.52 345.56 214.69 384.81 213.43 385.54"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "146.45 342.86 217.02 383.47 218.81 382.44 148.25 341.83 146.45 342.86",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "161.53 334.19 232.1 374.8 233.89 373.77 163.33 333.16 161.53 334.19",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "217.02 383.47 217.02 401.45 218.81 400.42 218.81 382.44 217.02 383.47",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "232.1 374.8 232.1 392.77 233.9 391.74 233.89 373.77 232.1 374.8",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pen--inject-136"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--pen--inject-136"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375.16,375.32a3,3,0,0,0-3-5.21h0l-2.62,1.52a1.48,1.48,0,0,0-.62,1.38,4.7,4.7,0,0,0,2.13,3.68,1.51,1.51,0,0,0,1.51.15l2.62-1.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371,376.69a1.51,1.51,0,0,0,1.51.15l2.62-1.52h0a3,3,0,0,0,1.49-2.51h0c-.14.84-1.39,1.55-2.85,2.39s-2.73.94-4.06-1.16c-1-1.53-.34-2.28.07-2.58l-.29.17a1.48,1.48,0,0,0-.62,1.38A4.7,4.7,0,0,0,371,376.69Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.15,386.12a9.35,9.35,0,1,0-9.36-16.18h0c-1.2.69-1.93,2.17-1.93,4.28a14.6,14.6,0,0,0,6.62,11.44c1.83,1,3.48,1.15,4.67.46Z",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.08,381.84a14.56,14.56,0,0,0-6.62-11.44c-1.82-1-3.47-1.15-4.67-.46l-57.72,33.41c-1.2.69-1.93,2.17-1.93,4.28a14.59,14.59,0,0,0,6.62,11.44c1.82,1.05,3.48,1.15,4.67.46l57.72-33.41C370.35,385.42,371.09,383.94,371.08,381.84Z",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.08,381.84a14.56,14.56,0,0,0-6.62-11.44c-1.82-1-3.47-1.15-4.67-.46l-57.72,33.41c-1.2.69-1.93,2.17-1.93,4.28a14.59,14.59,0,0,0,6.62,11.44c1.82,1.05,3.48,1.15,4.67.46l57.72-33.41C370.35,385.42,371.09,383.94,371.08,381.84Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.33,421.27a15,15,0,0,1-6.8-11.76c0-2.17.75-3.69,2-4.4l4.44-2.57c1.23-.71,2.93-.61,4.8.47a15,15,0,0,1,6.81,11.76c0,2.16-.76,3.69-2,4.4l-4.44,2.57C306.91,422.45,305.21,422.35,303.33,421.27Z",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.33,421.27a15,15,0,0,1-6.8-11.76c0-2.17.75-3.69,2-4.4l4.44-2.57c1.23-.71,2.93-.61,4.8.47a15,15,0,0,1,6.81,11.76c0,2.16-.76,3.69-2,4.4l-4.44,2.57C306.91,422.45,305.21,422.35,303.33,421.27Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.32,405.58a15,15,0,0,1,6.8,11.76c0,2.16-.75,3.69-2,4.4s-2.93.61-4.81-.47a15,15,0,0,1-6.8-11.76c0-2.17.75-3.69,2-4.4S301.44,404.5,303.32,405.58Z",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.32,405.58a15,15,0,0,1,6.8,11.76c0,2.16-.75,3.69-2,4.4s-2.93.61-4.81-.47a15,15,0,0,1-6.8-11.76c0-2.17.75-3.69,2-4.4S301.44,404.5,303.32,405.58Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.07,437c1.07-.62,2.54-.53,4.16.4a13,13,0,0,1,5.9,10.19c0,1.88-.65,3.2-1.72,3.81h0l-2.89.84h0a4.14,4.14,0,0,1-3.3-.6,12,12,0,0,1-5.43-9.38,4.2,4.2,0,0,1,1.12-3.16h0Z",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M246.07,437c1.07-.62,2.54-.53,4.16.4a13,13,0,0,1,5.9,10.19c0,1.88-.65,3.2-1.72,3.81h0l-2.89.84h0a4.14,4.14,0,0,1-3.3-.6,12,12,0,0,1-5.43-9.38,4.2,4.2,0,0,1,1.12-3.16h0Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M250.23,437.35a13,13,0,0,1,5.9,10.19c0,1.88-.65,3.2-1.72,3.81l52.06-30.13c1.07-.62,1.73-1.94,1.72-3.82a13,13,0,0,0-5.89-10.18c-1.63-.94-3.1-1-4.16-.41L246.07,437h0C247.14,436.33,248.61,436.42,250.23,437.35Z",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.19,452.22a3.64,3.64,0,0,0,1.56-3.42,11.64,11.64,0,0,0-5.32-9.13,3.72,3.72,0,0,0-3.71-.36h-.05c-3.33,1.95-11.51,8.82-13.44,13.4l.05.09a1.82,1.82,0,0,0-.16.79,4.3,4.3,0,0,0,2,3.37,1.74,1.74,0,0,0,.73.24h0C237.79,457.84,247.89,454.13,251.19,452.22Z",
    style: {
      fill: "#76ABAE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.19,417.4a10,10,0,0,0-.24-2.07l-52.07,30.14a9.36,9.36,0,0,1,.25,2.07c0,.12,0,.24,0,.36l52.06-30.14C308.18,417.64,308.19,417.53,308.19,417.4Zm6.06-.46a4.25,4.25,0,0,0,.14-.51l51.35-29.73c6.74-3.9,8.05-6.37,8-9.48-.5,2.8-6.66,6.34-7.46,6.81l-51.79,30c0,.26,0,.52,0,.77l-4.44,2.57a7.44,7.44,0,0,1-.31,2.17Zm-83.28,39,1.79.13s1,.68,5.65-.49,8.19-3.22,14.34-6.78a8.91,8.91,0,0,0-.36-2.41,74.58,74.58,0,0,1-14.84,7.71,30.09,30.09,0,0,1-6.75,1.58C230.86,455.77,230.91,455.86,231,455.94Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.31,453.55l-2.16,1.25c-.94.54-3,2.41-2.56,3.16s3.08-.1,4-.64h0l2.15-1.24s.24-.49-.34-1.48S231.31,453.55,231.31,453.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.51,458.25a1,1,0,0,0-.08-.78.93.93,0,0,0-.63-.45,1,1,0,0,0-.21.94C226.73,458.19,227.07,458.28,227.51,458.25Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Keys--inject-136"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--keys--inject-136"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M400.92,382.79c0,.1,0,.2,0,.3l2.12,17c.27,2.1,3.24,4,6.89,4.33a500.63,500.63,0,0,0,57.74,2.39c3.42-.06,5.89-1.54,5.88-3.49v-6.44c0-.09,0-.19,0-.29l-2.12-17c-.26-2.1-3.24-4-6.88-4.32a500.14,500.14,0,0,0-57.74-2.4c-3.42.06-5.89,1.55-5.9,3.5C400.92,376.47,400.93,382.23,400.92,382.79Zm8.76,9.34a3.1,3.1,0,0,1-1.47.26,3.67,3.67,0,0,1-1.68-.46,1.38,1.38,0,0,1-.78-1l-.73-5.86a3.16,3.16,0,0,1,1.46-.26,3.76,3.76,0,0,1,1.68.46,1.4,1.4,0,0,1,.78,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.94,376.67l2.12,17c.27,2.09,3.24,4,6.89,4.32a500.66,500.66,0,0,0,57.74,2.4c3.59-.06,6.13-1.7,5.87-3.8l-2.12-17c-.26-2.1-3.24-4-6.88-4.32a500.14,500.14,0,0,0-57.74-2.4C403.23,372.93,400.69,374.57,400.94,376.67Zm3.39,3c-.08-.74.87-1.29,2.15-1.24a3.76,3.76,0,0,1,1.68.46,1.44,1.44,0,0,1,.78,1l1.42,11.32c.09.73-.87,1.28-2.15,1.22a3.67,3.67,0,0,1-1.68-.46,1.38,1.38,0,0,1-.78-1Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451,376c0-.32.44-.55,1-.51q6.19.45,12.36,1.07c.31,0,.57.18.59.35l2.12,17.05v2.47c0,.16-.21.28-.51.29q-6.07.09-12.22,0c-.58,0-1.11-.3-1.16-.64L451,378.44V376Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.19,393.64,451,376c0-.34.42-.59,1-.55q6.19.45,12.36,1.07c.31,0,.57.18.59.35l2.12,17.05c0,.17-.2.3-.51.31q-6.07.11-12.22,0C453.77,394.27,453.24,394,453.19,393.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.42,374.69c0-.31.34-.55.87-.56q6.63,0,13.29.09c.58,0,1.1.3,1.14.63L429,392.77v2.48c0,.32-.43.56-1,.52-4.47-.28-8.93-.62-13.41-1-.54-.05-1-.33-1-.63l-2.11-17C411.4,377,411.42,374.69,411.42,374.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.72,374.85,429,392.77c0,.34-.41.59-1,.55-4.47-.27-8.93-.62-13.41-1-.54-.05-1-.32-1-.63l-2.11-17c0-.31.34-.55.87-.56q6.63,0,13.29.09C426.16,374.23,426.68,374.52,426.72,374.85Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.23,374.88v0c0-.3.4-.53.93-.51q8.63.26,17.25.8c.55,0,1,.32,1.06.64l2.22,17.89s0,0,0,0,0,2.43,0,2.44c0,.3-.4.52-.92.51-5.71-.1-11.46-.31-17.22-.62-.56,0-1-.31-1.08-.63l-2.25-18.09v-2.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.47,375.77l2.22,17.89c0,.32-.36.57-.91.56-5.71-.11-11.46-.32-17.22-.63-.56,0-1-.31-1.08-.63l-2.25-18.08c0-.32.37-.57.93-.55q8.63.26,17.25.8C448,375.17,448.43,375.45,448.47,375.77Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.81,383.52c0,.27.45.51.92.53a1,1,0,0,0,.61-.14L424,384l-.08-.64-1.62-.07a1.37,1.37,0,0,0-.65-.19C421.14,383.05,420.78,383.25,420.81,383.52Zm.33,0c0-.17.2-.3.49-.29a.85.85,0,0,1,.43.15l.06.05,1.46.06,0,.26-1.46-.06,0,0a.59.59,0,0,1-.41.11C421.41,383.85,421.16,383.7,421.14,383.54Zm-1.89.57.35.87a.53.53,0,0,0,.46.22l5.13.22c.24,0,.42-.1.41-.24l-.37-2.94c0-.14-.22-.26-.46-.27l-5.14-.21c-.21,0-.38.07-.4.19l-.14.85A2.31,2.31,0,0,0,419.25,384.11Zm.15-.65a2.08,2.08,0,0,1,0-.61l.14-.85a.1.1,0,0,1,.1-.05l5.14.21a.12.12,0,0,1,.12.07l.36,2.94s0,.06-.1.06L420,385a.13.13,0,0,1-.12-.06l-.36-.87A2.43,2.43,0,0,1,419.4,383.46Zm-3.1-.12c.09.71,1.17,1.33,2.4,1.38l.66,0,0-.19-.66,0c-1.05,0-2-.57-2-1.18s.72-1.07,1.77-1l.66,0,0-.18-.66,0C417.14,382.09,416.21,382.62,416.3,383.34Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.41,385.12c0,.27.44.51.91.53a1,1,0,0,0,.61-.14l1.63.06-.08-.64-1.63-.07a1.34,1.34,0,0,0-.65-.19C459.73,384.65,459.38,384.85,459.41,385.12Zm.33,0c0-.17.19-.3.49-.29a.85.85,0,0,1,.43.15l0,.05,1.47.06,0,.26-1.46-.06-.05,0a.56.56,0,0,1-.4.11C460,385.45,459.76,385.3,459.74,385.14Zm-1.89.57.35.87a.5.5,0,0,0,.46.22l5.13.22c.24,0,.42-.1.4-.24l-.36-2.94c0-.14-.23-.26-.47-.27l-5.13-.21c-.22,0-.38.07-.41.19l-.14.85A2.4,2.4,0,0,0,457.85,385.71Zm.15-.65a1.79,1.79,0,0,1,0-.61l.14-.85s.05-.05.1-.05l5.14.21c.06,0,.11,0,.11.07l.37,2.94s0,.06-.1.06l-5.14-.21c-.05,0-.1,0-.11-.06l-.36-.87A2.43,2.43,0,0,1,458,385.06Zm-3.69,1.27a3.53,3.53,0,0,0,3.17.13l.43-.25-.25-.14-.43.25a3,3,0,0,1-2.7-.12c-.8-.46-.89-1.16-.2-1.56l.44-.25-.25-.14-.43.25C453.28,385,453.38,385.79,454.31,386.33Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.47,380.24l.07.78h0a.13.13,0,0,0,0,.06l1.36.9-.89.5a.5.5,0,0,0-.31.52l.36,2a.72.72,0,0,0,.31.43l1.22.89a.64.64,0,0,1,.18.19l.75,1.26a1.62,1.62,0,0,0,1.27.58l.47,0c.47,0,.83-.19.8-.46l0-.23c.65-.06,1.07-.37,1-.76s-.55-.74-1.22-.85l-.41-3.27c.65-.07,1.07-.37,1-.76s-.55-.74-1.22-.86v-.09a.79.79,0,0,0-.48-.55,2.07,2.07,0,0,0-1-.23c-.51,0-.92.2-1,.48l-.29.81a.44.44,0,0,1-.22.23l-.11.06-1.31-.86-.07-.75h0c0-.05-.08-.1-.17-.1S436.46,380.19,436.47,380.24Zm.84,2.39,1.21-.67a.7.7,0,0,0,.3-.32l.28-.8a.78.78,0,0,1,.76-.36,1.53,1.53,0,0,1,.72.17.56.56,0,0,1,.35.4l0,.18s.08.09.16.1c.57.07,1,.35,1.06.67s-.34.58-.91.6c-.08,0-.13,0-.12.08l.42,3.43c0,.05.07.09.15.1.58.07,1,.35,1.07.68s-.34.57-.91.59c-.08,0-.13,0-.13.09l0,.31c0,.17-.2.29-.49.28l-.48,0a1.16,1.16,0,0,1-.93-.43l-.75-1.26a.8.8,0,0,0-.24-.25l-1.23-.89a.56.56,0,0,1-.23-.32l-.35-2A.37.37,0,0,1,437.31,382.63Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.73,417c0,1.61,1.21,3.33,3.56,4.61l12.92,7c6.64,3.63,16.35,4,22.05.82l1.38-.8c2.51-1.5,3.74-3.49,3.74-5.56,0-1.1,0-5.35,0-6.44,0-2.47-1.73-5.07-5.14-7.16L393,402.07c-3.78-2.31-9.6-2.7-13.26-.94a80.3,80.3,0,0,0-11.27,6.53,3.69,3.69,0,0,0-1.78,2.94C366.72,411.76,366.75,415.94,366.73,417Zm8.38-3.61a3.23,3.23,0,0,0-.51,1.29l-.82-.45Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.78,401.13a80.3,80.3,0,0,0-11.27,6.53c-3,2.08-2.13,5.41,1.78,7.55l12.92,7c6.64,3.62,16.35,4,22.05.81.47-.26.93-.53,1.38-.8,5.5-3.28,4.87-8.89-1.41-12.73L393,402.07C389.26,399.76,383.44,399.37,379.78,401.13Zm12.39,3.44a12,12,0,0,0-4.57,1.08,79.77,79.77,0,0,0-11.26,6.53,3.81,3.81,0,0,0-1.74,2.52l-1.86-1c-2.33-1.28-2.81-3.22-1.07-4.44s3.49-2.34,5.35-3.41,3.61-2,5.49-2.89a9.08,9.08,0,0,1,7.87.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.34,414.59a.77.77,0,0,0,0,1.45,2.82,2.82,0,0,0,2.5,0,.77.77,0,0,0,0-1.45A2.82,2.82,0,0,0,401.34,414.59Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.13,417a.76.76,0,0,0,0,1.44,2.75,2.75,0,0,0,2.5,0,.76.76,0,0,0,0-1.44A2.75,2.75,0,0,0,397.13,417Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.92,419.46a.76.76,0,0,0,0,1.44,2.73,2.73,0,0,0,2.49,0,.76.76,0,0,0,0-1.44A2.73,2.73,0,0,0,392.92,419.46Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.88,411.44a.76.76,0,0,0,0,1.44,2.73,2.73,0,0,0,2.49,0,.76.76,0,0,0,0-1.44A2.73,2.73,0,0,0,395.88,411.44Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.66,413.87a.77.77,0,0,0,0,1.45,2.82,2.82,0,0,0,2.5,0,.77.77,0,0,0,0-1.45A2.82,2.82,0,0,0,391.66,413.87Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.45,416.31a.76.76,0,0,0,0,1.44,2.75,2.75,0,0,0,2.5,0,.76.76,0,0,0,0-1.44A2.75,2.75,0,0,0,387.45,416.31Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.41,408.29a.76.76,0,0,0,0,1.44,2.75,2.75,0,0,0,2.5,0,.76.76,0,0,0,0-1.44A2.75,2.75,0,0,0,390.41,408.29Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.19,410.72a.76.76,0,0,0,0,1.44,2.75,2.75,0,0,0,2.5,0,.76.76,0,0,0,0-1.44A2.75,2.75,0,0,0,386.19,410.72Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382,413.15a.77.77,0,0,0,0,1.45,2.82,2.82,0,0,0,2.5,0,.77.77,0,0,0,0-1.45A2.82,2.82,0,0,0,382,413.15Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "401.63 427.3 407.86 423.7 422.5 432.15 423.17 434.14 427.36 435.5 429.16 437.73 431.32 438.48 431.95 439.61 433.11 439.66 433.77 440.4 436.78 441.38 438.13 444.78 438.13 447.67 432.26 446.89 430.55 445.15 429.27 444.76 429.18 444.1 427.23 443.74 425.94 442.49 422.06 441.45 419.71 439.03 416.27 438.64 401.63 430.19 401.63 427.3",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "407.86 423.7 401.63 427.3 416.27 435.75 419.71 436.14 422.06 438.56 425.94 439.6 427.23 440.85 429.18 441.2 429.27 441.87 430.55 442.26 432.26 444 438.13 444.78 436.78 441.38 433.77 440.4 433.11 439.66 431.95 439.61 431.32 438.48 429.16 437.73 427.36 435.5 423.17 434.14 422.5 432.15 407.86 423.7",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "432.26 444 432.26 446.89 430.55 445.15 430.55 442.26 432.26 444",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "429.27 441.87 429.27 444.76 429.18 444.1 429.18 441.2 429.27 441.87",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "427.23 440.85 425.94 439.6 425.94 442.49 427.23 443.74 427.23 440.85",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "419.71 436.14 419.71 439.03 422.06 441.45 422.06 438.56 419.71 436.14",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "416.27 435.75 416.27 438.64 401.63 430.19 401.63 427.3 416.2 435.81",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.22 428.28 409.31 428.8 433.67 442.87 434.58 442.34 410.22 428.28",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "434.19 442.57 433.67 442.87 409.7 429.03 410.22 428.73 434.19 442.57",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.22 428.73 410.22 428.28 409.31 428.8 409.7 429.03 410.22 428.73",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.37,399.82a1.93,1.93,0,0,0,0,.24,15.63,15.63,0,0,0,.2,2.31,11.65,11.65,0,0,0,1.35,4.1l1.63-.81a10.16,10.16,0,0,1-1.14-3.35,17.27,17.27,0,0,1-.2-2.24,2.44,2.44,0,0,1,0-.27c-.06-7.61,4.56-16.43,10.29-19.66a7.46,7.46,0,0,1,4.43-1.1l.31,0a4.8,4.8,0,0,1,1.52.56,5.49,5.49,0,0,1,1.79,1.71,9.64,9.64,0,0,1,1.34,3.53,16.11,16.11,0,0,1,.24,2.69,20.76,20.76,0,0,1-.31,3.65,1.37,1.37,0,0,0,.48.55.87.87,0,0,0,.23.16,2,2,0,0,0,.36.18l.34.12.2,0,.06,0a23.56,23.56,0,0,0,.48-4.75,20.73,20.73,0,0,0-.17-2.42,13.24,13.24,0,0,0-1-3.43,8.5,8.5,0,0,0-2.05-2.87,6.53,6.53,0,0,0-3.77-1.64h-.07a9.5,9.5,0,0,0-5.33,1.35C389.34,382.06,384.3,391.61,384.37,399.82Zm14,5.53,1.61,1a24,24,0,0,0,3.73-4.68,3.15,3.15,0,0,1-.69-1.53l-.09-.74A22.31,22.31,0,0,1,398.41,405.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M384.37,399.82a1.93,1.93,0,0,0,0,.24,15.63,15.63,0,0,0,.2,2.31,11.65,11.65,0,0,0,1.35,4.1l1.63-.81a10.16,10.16,0,0,1-1.14-3.35,17.27,17.27,0,0,1-.2-2.24,2.44,2.44,0,0,1,0-.27c-.06-7.61,4.56-16.43,10.29-19.66a7.46,7.46,0,0,1,4.43-1.1l.31,0a4.8,4.8,0,0,1,1.52.56,5.49,5.49,0,0,1,1.79,1.71,9.64,9.64,0,0,1,1.34,3.53,16.11,16.11,0,0,1,.24,2.69,20.76,20.76,0,0,1-.31,3.65,1.37,1.37,0,0,0,.48.55.87.87,0,0,0,.23.16,2,2,0,0,0,.36.18l.34.12.2,0,.06,0a23.56,23.56,0,0,0,.48-4.75,20.73,20.73,0,0,0-.17-2.42,13.24,13.24,0,0,0-1-3.43,8.5,8.5,0,0,0-2.05-2.87,6.53,6.53,0,0,0-3.77-1.64h-.07a9.5,9.5,0,0,0-5.33,1.35C389.34,382.06,384.3,391.61,384.37,399.82Zm14,5.53,1.61,1a24,24,0,0,0,3.73-4.68,3.15,3.15,0,0,1-.69-1.53l-.09-.74A22.31,22.31,0,0,1,398.41,405.35Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoan);
export default __webpack_public_path__ + "static/media/loan.520398373b49862bf74e9f4f95c2480f.svg";
export { ForwardRef as ReactComponent };